var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);


class DynamicVariables {
  constructor() {
    // Initial sync
    this.updateVars();

    // Listen for resize on the best-supported API
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.updateVars.bind(this));
    } else {
      window.addEventListener("resize", this.updateVars.bind(this));
    }
  }

  updateVars() {
    // Width: use layout viewport width
    const vw = document.documentElement.clientWidth;

    // Height: prefer visualViewport, else layout viewport height
    const vh = window.visualViewport
      ? window.visualViewport.height
      : document.documentElement.clientHeight;

    document.documentElement.style.setProperty("--viewport-width",  `${vw}px`);
    document.documentElement.style.setProperty("--viewport-height", `${vh}px`);
  }
}

// Instantiate it once on page load
const dynamicVars = new DynamicVariables();


let alreadyDelegated = false;

class Popup {
  constructor(element, additionalOverlay) {
    this.element = element;
    this.delegateBody = new Delegate(document.body);
    this.headerTransparent = document
      .querySelector("#header")
      .classList.contains("Header--Transparent");

    // overlay container selection
    if (additionalOverlay === true) {
      this.pageOverlayElement = responsive.matchesBreakpoint('lap_and_up')
        ? document.querySelector(".localizationOverlay.desktop")
        : document.querySelector(".localizationOverlay.mobile");
    } else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");

      console.log('ovde sam');
    }

    this.onClickOutsideListener = this.closeModal.bind(this);
    this._outsideDesktopHandler = null;
    this._outsideDesktopScroll  = null;

    // placeholders for swipe handlers
    this._swipe = { handle: null, wrap: null, startY:0, moveY:0, 
      onStart: null, onMove: null, onEnd: null 
    };

    if (!alreadyDelegated) this.bindEvents();
  }

  bindEvents() {
    alreadyDelegated = true;
    this.delegateBody.on("click",             '[data-action="open-modal"]',  this.openModal.bind(this));
    this.delegateBody.on("click",             '[data-action="close-modal"]', this.closeModal.bind(this));
    this.delegateBody.on("drawer:close-other", this.closeModal.bind(this));
    this.delegateBody.on("menu:open",          this.closeModal.bind(this));
    this.delegateBody.on("keydown",            this.onEsc.bind(this));
  }

  onEsc(e) {
    if (e.key === 'Escape') this.closeModal(e);
  }

  openModal(e) {
    e.preventDefault();
    e.stopPropagation();

    const modalId = e.target.closest("[aria-controls]").getAttribute("aria-controls");
    const modal   = document.getElementById(modalId);

    // toggle close if already open
    if (modal.getAttribute("aria-hidden")==="false") {
      return this.closeModal(e);
    }
    this.activeModal = modal;

    // close other panels/search
    this.element.dispatchEvent(new CustomEvent("close:search",{ bubbles:true }));
    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.element.dispatchEvent(new CustomEvent("close:other",{ bubbles:true }));
      if (this.headerTransparent)
        document.querySelector("#header").classList.remove("Header--Transparent");
    }

    if (modal.id === "modal-country-desktop") {
      // ─── desktop: overlay-free, click & scroll outside to close ───
      setTimeout(() => {
        this._outsideDesktopHandler = evt => {
          if (!modal.contains(evt.target)) this.closeModal(evt);
        };
        document.addEventListener("mousedown", this._outsideDesktopHandler);

        this._outsideDesktopScroll = () => this.closeModal(new Event('scroll'));
        window.addEventListener("scroll", this._outsideDesktopScroll, { passive:true });
      }, 0);
    } else {
      // ─── mobile & others ───
      // show overlays & lock scroll
      
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);

      const scrollable = modal.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(scrollable, bodyScrollLockOptions);

      // **attach swipe-to-close** on mobile country modal
      if (modal.id === "modal-country-mobile") {
        this._attachSwipe(modal);
      }
    }

    // reveal
    e.target.setAttribute("aria-expanded","true");
    modal.setAttribute("aria-hidden","false");
    modal.getBoundingClientRect();
    requestAnimationFrame(() => modal.setAttribute("aria-expanded","true"));
    trapFocus(modal);
  }

  closeModal(e) {
    e.preventDefault();

    const modal = this.activeModal ||
      document.body.querySelector('.Popup[aria-hidden="false"]');
    if (!modal) return;

    if (modal.id === "modal-country-desktop") {
      // remove desktop handlers
      if (this._outsideDesktopHandler) {
        document.removeEventListener("mousedown", this._outsideDesktopHandler);
        this._outsideDesktopHandler = null;
      }
      if (this._outsideDesktopScroll) {
        window.removeEventListener("scroll", this._outsideDesktopScroll);
        this._outsideDesktopScroll = null;
      }
    } else {
      // teardown mobile overlay + unlock scroll
      this.pageOverlayElement?.removeEventListener("click", this.onClickOutsideListener);
      this.pageOverlayElement?.classList.remove("is-visible");

      const scrollable = modal.querySelector("[data-scrollable]");
      bodyScrollLock.enableBodyScroll(scrollable);

      // **remove swipe handlers** if mobile country modal
      if (modal.id === "modal-country-mobile") {
        this._detachSwipe();
      }
    }

    // reset opener button
    const opener = document.querySelector(`[aria-controls="${modal.id}"]`);
    opener?.setAttribute("aria-expanded","false");

    // hide with transition/animation
    modal.setAttribute("aria-expanded","false");
    const endEvt = modal.classList.contains("account__popup") ? "animationend" : "transitionend";
    modal.addEventListener(endEvt, () => modal.setAttribute("aria-hidden","true"), { once:true });

    if (this.headerTransparent && responsive.matchesBreakpoint('lap_and_up'))
      document.querySelector("#header").classList.add("Header--Transparent");
  }

  _attachSwipe(modal) {
    const wrap   = modal;
    const handle = wrap.querySelector('.country-selector__swipe-element');
    if (!handle) return;

    const swipe = this._swipe;
    swipe.wrap   = wrap;
    swipe.handle = handle;
    swipe.startY = 0;
    swipe.moveY  = 0;

    swipe.onStart = e => {
      swipe.startY = e.touches[0].clientY;
      wrap.style.transition = 'none';
    };
    swipe.onMove = e => {
      if (!swipe.startY) return;
      swipe.moveY = e.touches[0].clientY;
      const dy = swipe.moveY - swipe.startY;
      if (dy > 0) wrap.style.transform = `translateY(${dy}px)`;
    };
    swipe.onEnd = e => {
      wrap.style.transition = '';
      if (swipe.moveY - swipe.startY > 80) {
        this.closeModal(e);
      } else {
        wrap.style.transform = '';
      }
      swipe.startY = swipe.moveY = 0;
    };

    handle.addEventListener('touchstart', swipe.onStart);
    handle.addEventListener('touchmove',  swipe.onMove);
    handle.addEventListener('touchend',   swipe.onEnd);
  }

  _detachSwipe() {
    const swipe = this._swipe;
    if (!swipe.handle) return;

    swipe.handle.removeEventListener('touchstart', swipe.onStart);
    swipe.handle.removeEventListener('touchmove',  swipe.onMove);
    swipe.handle.removeEventListener('touchend',   swipe.onEnd);

    // reset transform
    swipe.wrap.style.transform = '';
    swipe.wrap.style.transition = '';

    swipe.handle = swipe.wrap = swipe.onStart = swipe.onMove = swipe.onEnd = null;
  }
}

customElements.define("popup-element", Popup);




class Popup2 {
  constructor() {
    // Use a delegate for event handling on document.body.
    this.delegateBody = new Delegate(document.body);
    // Maintain a stack of active popups.
    this.activePopups = [];
    this.onPopupOpen = null;
    this.onPopupClose = null;
    this.bindEvents();
  }

  bindEvents() {
    // Bind a listener for clicks on toggle buttons.
    this.delegateBody.on(
      'click',
      '[data-action="toggle-popup"]',
      this.handleOpenOptions.bind(this)
    );

    // Listen for the custom "drawer:close-other" event to close all open popups.
    this.delegateBody.on(
      'drawer:close-other',
      this.handleDrawerCloseOther.bind(this)
    );

    this.delegateBody.on(
      'edit-img:open-popup',
      this.handleOpenOptions.bind(this)
    );

    // Bind keydown directly on the delegate element so it fires only once.
    this.delegateBody.on('keydown', this.handleEscape.bind(this));
  }

  // This method is called when a toggle button is clicked.
  handleOpenOptions(event) {
    event.stopPropagation();
    event.preventDefault();


    const toggleButton = event.target.closest('[data-action="toggle-popup"]');
    if (toggleButton) {
      this.togglePopup(toggleButton);
      return;
    }

    // If a click occurs on the overlay of the top-most popup, close that popup.
    if (this.activePopups.length) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      const overlay = this.getOverlayElement(topPopup);
      if (overlay && overlay.contains(event.target)) {
        this.closePopup(topPopup);
      }
    }
  }

  // Handle keydown events.
  // Only close the top-most popup when Esc is pressed.
  handleEscape(event) {
    if (event.key === 'Escape' && this.activePopups.length) {
      event.preventDefault();
      event.stopPropagation();
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if(topPopup.querySelector('[data-action="toggle-popup"]')){
        topPopup.querySelector('[data-action="toggle-popup"]').click();
      } else {
        this.closePopup(topPopup);
      }

    }
  }

  // Toggle the popup associated with the given button.
  togglePopup(button) {
    const popupId = button.getAttribute('aria-controls');
    if (!popupId) return;

    const popupElement = document.getElementById(popupId);
    if (!popupElement) return;

    // Determine if this popup should be treated as a child popup.
    const isChild = button.getAttribute('data-child-popup') === 'true';

    // If the popup is already open, close it; otherwise, open it.
    if (popupElement.getAttribute('aria-hidden') === 'false') {
      this.closePopup(popupElement);
    } else {
      this.openPopup(popupElement, isChild);
    }
  }

  // Open the popup element.
  // If it's not a child popup, close all currently open popups.
  openPopup(popupElement, isChild = false) {
    // Mark the popup element as a child (or not) for later checks.
    popupElement._isChild = isChild;

    // Ensure the popup is visible before starting any animations.
    popupElement.style.display = '';

    // If this is a parent popup, close any other open popups.
    if (!isChild) {
      while (this.activePopups.length) {
        this._closePopup(this.activePopups.pop());
      }
    }

    popupElement.setAttribute('aria-hidden', 'false');
    popupElement.removeAttribute('inert');
    requestAnimationFrame(() => {
      popupElement.setAttribute('aria-expanded', 'true');
      if (typeof this.onPopupOpen === 'function') {
        this.onPopupOpen(popupElement);
      }
    });

    // Store the scrollable element reference on the popup for later use.
    const focus = popupElement.querySelector('[data-scrollable]');

    if (focus) {
      popupElement._scrollableElement = focus;
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    } else {
      popupElement._scrollableElement = document.body;
      bodyScrollLock.disableBodyScroll(document.body, bodyScrollLockOptions);
    }

    trapFocus(popupElement);
    // If the popup specifies an overlay, find it, display it, and attach a click listener.
    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.add('is-visible');
      const handleOverlayClick = (e) => {
        e.preventDefault();
        this.closePopup(popupElement);
      };
      // Store the handler so it can be removed later.
      popupElement._overlayClickHandler = handleOverlayClick;
      overlay.addEventListener('click', handleOverlayClick);
    }

    // Push this popup onto the active stack.
    this.activePopups.push(popupElement);
  }

// Close the popup element.
closePopup(popupElement) {
  const index = this.activePopups.indexOf(popupElement);
  if (index !== -1) {
    // Save the scrollable element from the popup being closed.
    const closedScrollEl = popupElement._scrollableElement;
    this._closePopup(popupElement);
    this.activePopups.splice(index, 1);

    // If there is a new top popup, check for its scrollable element.
    if (this.activePopups.length > 0) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (topPopup._scrollableElement) {
        // Reapply the scroll lock to the new top popup's scrollable element.
        bodyScrollLock.disableBodyScroll(topPopup._scrollableElement, bodyScrollLockOptions);
      }
    } else {
      // No active popups remain; remove the scroll lock from the closed element.
      if (closedScrollEl) {
        bodyScrollLock.enableBodyScroll(closedScrollEl);
      }
    }
  }
}


  // Internal method to remove open styles and attributes from the popup,
  // then wait for the transition to finish before setting display: none.
  _closePopup(popupElement) {
    popupElement.setAttribute('aria-expanded', 'false');

    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.remove('is-visible');
      if (popupElement._overlayClickHandler) {
        overlay.removeEventListener('click', popupElement._overlayClickHandler);
        delete popupElement._overlayClickHandler;
      }
    }

    removeTrapFocus(popupElement);

    const transitionEndHandler = () => {
      popupElement.setAttribute('aria-hidden', 'true');
      popupElement.setAttribute('inert', '');
      popupElement.removeEventListener('transitionend', transitionEndHandler);
      // Trigger the close callback after the transition ends.
      if (typeof this.onPopupClose === 'function') {
        this.onPopupClose(popupElement);
      }
    };

    setTimeout(() => {
      popupElement.setAttribute('aria-hidden', 'true');
      popupElement.setAttribute('inert', '');
      popupElement.removeEventListener('transitionend', transitionEndHandler);
    }, 50);

    popupElement.addEventListener('transitionend', transitionEndHandler);
  }

  // Method to handle the custom event "drawer:close-other".
  // It closes all currently open popups.
  handleDrawerCloseOther(event) {
    event.preventDefault();
    this.closeAllPopups();
  }

  // Method to close all open popups.
  closeAllPopups() {
    while (this.activePopups.length) {
      const popup = this.activePopups.pop();
      this._closePopup(popup);
    }
  }

  // Retrieve the overlay element based on the popup's data-overlay attribute.
  getOverlayElement(popupElement) {
    const overlayClass = popupElement.getAttribute('data-overlay');
    if (overlayClass) {
      return document.querySelector(`.${overlayClass}`);
    }
    return null;
  }
}

window.globalPopup = new Popup2();

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.thumbnailContainer = document.getElementById("pswp-thumbnails-inside");
    this.imageElements = Array.from(this.element.querySelectorAll(".ProductSliderCell--Zoom img"));

    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));

    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }

  photoswiperClose() {
    this.photoSwipeInstance.close();
    // Commented out as it breaks functionality on iOS devices
    // if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
    //   document.documentElement.classList.remove("pswp-open-in-ios");
    // }
    document.body.classList.remove('scrollLock');
  }

  initPhotoSwipe() {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide].querySelector('.ProductSlider--Element').getAttribute(
        'data-image-position'
      )
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }



    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (item.classList.contains('ProductSliderCell--Zoom') && item.querySelector('img')) {
        images.push(item.querySelector('img'));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(target.querySelector('.ProductSlider--Element').getAttribute('data-image-position'));

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), imagePosition);
  }

  createPhotoSwipeItemsFromImages(images) {
    const isDesktop = responsive.matchesBreakpoint("lap_and_up");

    return images.map(function (image) {
      if (isDesktop) {
        const requestedWidth = window.innerWidth * 0.425;
        const requestedHeight = requestedWidth; // square for desktop

        return {
          msrc: image.currentSrc || image.src,
          w: requestedWidth,
          h: requestedHeight,
          initialZoomLevel: 0.62,
          src: image.dataset.originalSrc,
        };
      } else {
        const naturalWidth = image.naturalWidth || parseInt(image.getAttribute("width"));
        const naturalHeight = image.naturalHeight || parseInt(image.getAttribute("height"));
        const targetHeight = window.innerHeight;

        const aspectRatio = naturalWidth / naturalHeight;
        const requestedHeight = targetHeight;
        const requestedWidth = requestedHeight * aspectRatio;

        return {
          msrc: image.currentSrc || image.src,
          w: requestedWidth,
          h: requestedHeight,
          initialZoomLevel: 0.62,
          src: image.dataset.originalSrc,
        };
      }
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        closeOnScroll: false,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen('close', this.photoswiperClose.bind(this));
    // Commented out as it breaks functionality on iOS devices
    // if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
    //   document.documentElement.classList.add("pswp-open-in-ios");
    // }

    this.renderModalThumbnails(items);
    this.photoSwipeInstance.init();
    document.body.classList.add('scrollLock');
    this.enableThumbnailScroll();
  }

  enableThumbnailScroll() {
    const thumbs = document.getElementById("pswp-thumbnails-inside");
    if (thumbs) {
      thumbs.addEventListener(
        "wheel",
        (e) => {
          e.stopPropagation();
        },
        { passive: true }
      );
    }
  }

  renderModalThumbnails(items) {
    const container = document.getElementById("pswp-thumbnails-inside");
    if (!container) return;

    container.innerHTML = ""; // Clear existing
    items.forEach((item, index) => {
      const thumb = document.createElement("img");
      thumb.src = item.msrc;
      thumb.className = "pswp-modal-thumb";
      thumb.dataset.index = index;

      thumb.addEventListener("click", () => {
        if (this.photoSwipeInstance) {
          this.photoSwipeInstance.goTo(index);
        }
      });

      container.appendChild(thumb);
    });

    this.updateActiveModalThumbnail(0);
  }

  updateActiveModalThumbnail(index) {
    const thumbs = document.querySelectorAll("#pswp-thumbnails-inside .pswp-modal-thumb");
    thumbs.forEach((el, i) => {
      el.classList.toggle("active", i === index);
    });
  }

  onslideChanged() {
    const currentIndex = this.photoSwipeInstance.getCurrentIndex();
    this.updateActiveModalThumbnail(currentIndex);

    const prevBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--prev");
    const nextBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--next");

    if (currentIndex === 0) {
      prevBtn.setAttribute("disabled", "disabled");
    } else {
      prevBtn.removeAttribute("disabled");
    }

    if (currentIndex + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
      nextBtn.setAttribute("disabled", "disabled");
    } else {
      nextBtn.removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover = false, changeOverlay = false) {
    this.host               = element;
    this.popover            = popover;
    this.changeOverlay      = changeOverlay;
    this.domDelegate        = new Delegate(this.host);
    this.delegateBody       = new Delegate(document.body);
    this.isOpen             = false;

    // core elements
    this.button             = this.host.querySelector(".RevolutionSelectbox--Button");
    this.panel              = this.host.querySelector(".RevolutionSelectbox--Content");
    this.inner              = this.host.querySelector(".RevolutionSelectbox--InnerContent");

    // overlay (popover mode)
    if (this.popover) {
      this.panel.classList.remove("RevolutionSelectbox--animation");
      this.panel.classList.add("PopoverContent");
      this.overlayEl = this.changeOverlay
        ? document.querySelector(".localizationOverlay")
        : document.querySelector(".pageOverlay");
    }

    // wire events
    this._onToggle        = this.toggleDropdown.bind(this);
    this._onOutsideClick  = this.onClickOutside.bind(this);
    this._onSelectChange  = this.onItemSelect.bind(this);

    this.domDelegate.on("click", "[data-action=toggle-selectbox]", this._onToggle);
    this.domDelegate.on("click", "[data-action=selectbox-change]", this._onSelectChange);

    // ensure only one open at once
    this.delegateBody.on("close:all-selectboxes", (e) => {
      if (e.target !== this.host) this.close();
    });

    // other global closes
    this.delegateBody.on("drawer:close-other", () => this.close());
    this.delegateBody.on("menu:open",            () => this.close());

    // make it visible/trappable
    trapFocus(this.host);
    this.host.style.display = "block";
  }

  toggleDropdown(evt, btn) {
    evt.preventDefault();
    if (this.isOpen) this.close();
    else             this.open(btn);
  }

  open(btn) {
    // tell siblings to close
    this.host.dispatchEvent(new CustomEvent("close:all-selectboxes", { bubbles: true }));

    // aria
    btn.setAttribute("aria-expanded", "true");
    this.host.setAttribute("aria-expanded", "true");

    // overlay/focus-lock
    if (this.popover) {
      this.overlayEl.classList.add("is-visible");
      document.querySelector(".header-overlay")?.classList.add("is-visible");
      this.overlayEl.addEventListener("click", this._onOutsideClick);
    }

    // scroll-lock
    if (this.changeOverlay || this.host.closest(".focusable.country-selector")) {
      bodyScrollLock.disableBodyScroll(this.panel, bodyScrollLockOptions);
    }

    // fade-in
    this.panel.style.display    = "block";
   requestAnimationFrame(() => {
    this.panel.setAttribute("aria-hidden", "false");
  });
    // ensure CSS has: .RevolutionSelectbox--Content { opacity:0; transition:opacity .25s ease } 
    // and .RevolutionSelectbox--Content[aria-hidden="false"] { opacity:1 }
    btn.setAttribute("aria-expanded", "true");
    this.host.setAttribute("aria-expanded", "true");

    // outside clicks
    setTimeout(() => window.addEventListener("click", this._onOutsideClick), 0);
    this._onKeydown = this.initTypeSearch(this.inner);
    this.isOpen = true;
  }

  close() {
    if (!this.isOpen) return;

    // remove overlay
    if (this.popover) {
      this.overlayEl.classList.remove("is-visible");
      document.querySelector(".header-overlay")?.classList.remove("is-visible");
      this.overlayEl.removeEventListener("click", this._onOutsideClick);
    }

    // unlock scroll
    if (this.changeOverlay || this.host.closest(".focusable.country-selector")) {
      bodyScrollLock.enableBodyScroll(this.panel, bodyScrollLockOptions);
    }

    // fade-out
    this.panel.setAttribute("aria-hidden", "true");
    this.panel.addEventListener("transitionend", () => {
      this.panel.style.display = "none";
    }, { once: true });

    // aria
    this.button.setAttribute("aria-expanded", "false");
    this.host.setAttribute("aria-expanded", "false");

    // cleanup
    window.removeEventListener("click", this._onOutsideClick);
    window.removeEventListener("keydown", this._onKeydown);
    removeTrapFocus(this.host);
    this.isOpen = false;
  }

  onClickOutside(evt) {
    if (!evt.composedPath().includes(this.host)) {
      this.close();
    }
  }

  onItemSelect(evt) {
    const item      = evt.target.closest(".RevolutionSelectbox--Item");
    const id        = item.dataset.selectboxid;
    const inputEl   = this.host.querySelector("#" + id);
    const nameText  = item.dataset.name;

    // update real input
    if (inputEl.nodeName === "SELECT") {
      inputEl.value = item.dataset.value;
      inputEl.dispatchEvent(new Event("change"));
    } else {
      inputEl.value = item.dataset.value;
    }

    // update button text
    const wrapper = this.button.querySelector(".country-flag--wrapper");
    const title   = this.button.querySelector(".RevolutionSelectbox--Title");
    title.textContent = nameText;
    // swap flag
    wrapper.querySelector(".revolution-selectbox__flag")?.remove();
    const flag = item.querySelector(".revolution-selectbox__flag");
    if (flag) wrapper.insertBefore(flag.cloneNode(true), title);

    // fire event if needed
    if (id === "country-selector__country-code") {
      this.host.dispatchEvent(new CustomEvent("change:countrySelector", {
        bubbles: true,
        detail: {
          currency : item.dataset.currency,
          country  : item.dataset.value,
          languages: item.dataset.languages
        }
      }));
    }

    this.close();
  }

  initTypeSearch(container) {
    let query = "";
    return (e) => {
      if (!queryTimer) clearTimeout(queryTimer);
      query += e.key;
      queryTimer = setTimeout(() => query = "", 500);

      const items = Array.from(container.querySelectorAll(".RevolutionSelectbox--Item"));
      const match = items.find(i => i.textContent.toLowerCase().startsWith(query.toLowerCase()));
      match?.focus();
    };
  }
}

customElements.define("revolution-selectbox", RevolutionSelectbox);



class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  addToCart() {
    var _this = this;
    event.preventDefault();

    document.querySelector("search-bar").setAttribute("aria-hidden", "true");
    document.querySelector("search-bar").style.display = "";
    var addToCartButton = event.target;
    this.pageLoader.style.width = "100%";
    addToCartButton.setAttribute("disabled", "disabled");

    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");

    var formHelper = new Form();
    const mainItem = formHelper.serialize(formElement);

    const items = [{
      id: mainItem.id,
      quantity: mainItem.quantity || 1,
      properties: mainItem.properties || {}
    }];

    // Addon products
    const addonInputs = this.element.querySelectorAll('.pdp-addon-product-card__checkbox:checked');
    addonInputs.forEach(input => {
      items.push({
        id: input.dataset.productid,
        quantity: 1,
      });
    });

    // Accessory products
    const accessoryInputs = this.element.querySelectorAll('.pdp-accessory-product-card__checkbox:checked');
    accessoryInputs.forEach(input => {
      const wrapper = input.closest('accessory-product-quantity');
      const qtyInput = wrapper?.querySelector('.quantity-input');
      const quantity = parseInt(qtyInput?.value) || 1;

      if (quantity > 0) {
        items.push({
          id: input.dataset.productid,
          quantity: quantity
        });
      }
    });

    console.log("Sending to cart:", items);

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify({ items }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === 'page') {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variants: items.map(item => item.id),
              total_quantity: items.reduce((sum, item) => sum + parseInt(item.quantity), 0)
            },
          })
        );
      } else {
        response.json().then(function (content) {
          const errorContainer = _this.element.querySelector(".ProductForm--Error");
          if (errorContainer) {
            errorContainer.classList.add("visible");
            setTimeout(() => errorContainer.classList.remove("visible"), 2500);
          } else {
            const errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
            setTimeout(() => errorMessageElement.remove(), 2500);
          }

          _this.pageLoader.style.left = "unset";
          _this.pageLoader.style.right = "0px";
          _this.pageLoader.style.width = "0%";
          setTimeout(() => {
            _this.pageLoader.style.left = "0px";
            _this.pageLoader.style.right = "unset";
          }, 550);
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.bindEvents();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;

    switch (this.breakpoint) {
      case 'lap_and_up':
        // For lap_and_up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case 'pocket':
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on(
        "click",
        selector,
        this.toggleDropdown.bind(this)
      );
    }
  }


  openDropdown(elem, target) {
    this.allDropdowns.forEach((dropdown) => {
      if (
          dropdown !== target.closest(".Dropdown") &&
          dropdown.querySelector("[aria-expanded='true']") &&
          !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown, true);
      }
    });

    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    DropdownButton.setAttribute("aria-expanded", "true");


    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeDropdown(elem, target) {
    // Close the dropdown by setting appropriate attributes and performing animation


    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", "false");

    DropdownContent.classList.add('dropdown-closing');

    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        DropdownContent.setAttribute("aria-hidden", "true");
        DropdownContent.classList.remove('dropdown-closing');
        elem.removeEventListener("transitionend", transitionEnded);
      }
    };

    elem.addEventListener("transitionend", transitionEnded);

  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isDropdownAnimating) return; // Block clicks during animation
    this.isDropdownAnimating = true;
    setTimeout(() => {
      this.isDropdownAnimating = false;
    }, 500);

    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (target.classList.contains("info__dropdown-button")) {
      document.querySelectorAll(".info__dropdown-button[aria-expanded='true']").forEach(btn => {
        if (btn !== target) {
          const dropdown = btn.closest(".Dropdown");
          if (dropdown) this.closeDropdown(dropdown);
        }
      });
    }

    if (isOpen) {
      // If dropdown is open, close it
      this.closeDropdown(mainDropdown, target);
    } else {
      // If dropdown is closed, open it
      this.openDropdown(mainDropdown, target);
    }

    this.syncDropdownExpandedStates();
  }

  syncDropdownExpandedStates() {
    this.allDropdowns.forEach(dropdown => {
      const btn = dropdown.querySelector(".info__dropdown-button");
      if (btn) {
        const isExpanded = btn.getAttribute("aria-expanded") === "true";
        dropdown.setAttribute("aria-expanded", isExpanded);
      }
    });
  }

  getPreviousDropdownButton(currentButton) {
    const buttons = Array.from(document.querySelectorAll(".info__dropdown-button"));
    const index = buttons.indexOf(currentButton);

    if (index > 0) {
      return buttons[index - 1];
    }

    return null;
  }
}


new Dropdown();


class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });


  }
}

class Drawer {

  static openDrawers = [];
  static _escapeHandlerAdded = false;

constructor(element, options = {}) {
    this.element = element;
    this.delegateBody = new Delegate(document.body);

    // pick the correct backdrop:
    const isAccount = this.element.id === 'accountDrawer';
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.pageOverlayElement = (isAccount && this.breakpoint !== 'desktop')
      ? document.querySelector('.localizationOverlay')
      : document.querySelector('.pageOverlay');

    // listen for outside clicks
    this._closeListener = this.closeDrawer.bind(this);
    this.delegateBody.on('drawer:close-other', this._closeListener);

    // global Esc handler (once)
    if (!Drawer._escapeHandlerAdded) {
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          const top = Drawer.openDrawers.slice(-1)[0];
          if (top) top.closeDrawer();
        }
      });
      Drawer._escapeHandlerAdded = true;
    }

    // re-adjust on resize
    window.addEventListener('resize', () => this._adjustContentHeight());

    // swipe handle, if present
    this.handle = this.element.querySelector('.drawer__swipe-element');
    if (this.handle) this.initDragHandle();

    // delegate open/close/toggle clicks
    this.bindEvents();

    // hooks
    this.onOpen = options.onOpen || function(){};
    this.onClose = options.onClose || function(){};
    this.isOpen = false;
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
  }

_adjustContentHeight() {
    if(this.element.id == 'Drawer') return; // don't adjust height for the sidebar drawer
    const wrapper    = this.element;
    const buffer     = 40; // px you want to leave at the top
    const contentBox = wrapper.querySelector('.Drawer--Content');
    if (!contentBox) return;

    // 1) measure fixed bits
    const headerH = wrapper.querySelector('.drawer-header')?.offsetHeight || 0;
    const handleH = this.breakpoint !== 'desktop'
      ? wrapper.querySelector('.drawer__swipe-element')?.offsetHeight || 0
      : 0;
    const footerH = wrapper.querySelector('.customerAccunt--DrawerFooter')?.offsetHeight || 0;

    const reserved     = headerH + handleH + footerH;
    const maxWrapperH  = window.innerHeight - buffer;
    const neededWrapperH = contentBox.scrollHeight + reserved;

    if (neededWrapperH <= maxWrapperH) {
      // everything fits → let it auto-size (clears any old inline px height)
      wrapper.style.height       = '';
      contentBox.style.maxHeight = '';
      contentBox.style.overflowY = '';
    } else {
      // too tall → cap the wrapper and make only the content scroll
      if(this.element.classList.contains('cart-drawer') && this.breakpoint != 'desktop')
        wrapper.style.height       = `${maxWrapperH}px`;
      else {
        contentBox.style.maxHeight = `${maxWrapperH - reserved}px`;
        contentBox.style.overflowY = 'auto';
      }
    }
  }






  initDragHandle() {
    let startY = 0, currentY = 0;
    const threshold = 80;
    const wrap = this.element;

    this.handle.addEventListener('touchstart', e => {
      startY = e.touches[0].clientY;
      wrap.style.transition = 'none';
    });

    this.handle.addEventListener('touchmove', e => {
      if (!startY) return;
      currentY = e.touches[0].clientY;
      const dy = currentY - startY;
      if (dy > 0) wrap.style.transform = `translateY(${dy}px)`;
    });

    this.handle.addEventListener('touchend', e => {
      wrap.style.transition = '';

      if (currentY - startY > threshold) {
        this.closeDrawer(e);
        wrap.style.transform = '';
      } else {
        wrap.style.transform = '';
      }

      startY = currentY = 0;
    });
  }


  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

openDrawer(event) {
  // 1) stop any native navigation
  if (event) event.preventDefault();

  // 2) close any search UI & size
  this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
  this._adjustContentHeight();

  // 3) cart-drawer special events
  if (this.element.id === 'cart-drawer') {
    this.element.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent('drawer:close-other', { bubbles: true }));
  }

  // 4) already open?
  if (this.isOpen) return false;

  // 5) "hamburger" styling for main sidebar
  if (this.element.id === 'Drawer') {
    document.querySelector('.header').classList.remove('Header--Transparent');
    document.querySelector('.Drawer--Close').style.display = 'block';
    document.body.querySelector('.header-hamburger-btn').classList.add('is-active');
    this.element.dispatchEvent(new CustomEvent('sidebar-drawer:open', { bubbles: true }));
  }
    if (document.querySelector('.Header--Transparent')) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
      this.headerTransparent = true;
    }
  

  // 6) mark this drawer open
  this.element.setAttribute('aria-expanded', 'true');

  // 7) show the correct backdrop (localizationOverlay vs pageOverlay)
  if (this.element.id !== 'Drawer') {
    this.pageOverlayElement.classList.add('is-visible');
    this.pageOverlayElement.addEventListener('click', this._closeListener);
  }

  this._overlayObserver = new MutationObserver(() => {
  if (this.isOpen && !this.pageOverlayElement.classList.contains('is-visible')) {
    this.pageOverlayElement.classList.add('is-visible');
  }
});
this._overlayObserver.observe(this.pageOverlayElement, { attributes: true, attributeFilter: ['class'] });

  // 8) always lock body scroll
  const focusEl = this.element.querySelector('[data-scrollable]');
  bodyScrollLock.disableBodyScroll(focusEl, bodyScrollLockOptions);
  document.body.classList.add('scrollLock');

  // 9) finalize
  this._adjustContentHeight();
  this.isOpen = true;
  Drawer.openDrawers.push(this);
  setTimeout(() => trapFocus(this.element), 400);
  this.onOpen();
  return false;
}

closeDrawer(event) {
  // 1) if not open, nothing to do
  if (!this.isOpen) return;

  // 2) stop any native navigation
  if (event) event.preventDefault();

  // 3) mark closed
  this.element.setAttribute('aria-expanded', 'false');

  // 4) hide this drawer's backdrop
  if (this.element.id !== 'Drawer') {
    this.pageOverlayElement.classList.remove('is-visible');
    this.pageOverlayElement.removeEventListener('click', this._closeListener);
  }

  // 5) remove from the open-stack
  Drawer.openDrawers = Drawer.openDrawers.filter(d => d !== this);
  this.isOpen = false;

  // 6) only unlock body *if no other drawer is still open*
  if (Drawer.openDrawers.length === 0) {
    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.classList.remove('scrollLock');
    document.body.removeAttribute('style');
  }
  const opts = JSON.parse(document.querySelector('.header').getAttribute('data-settings'));
  // 7) special sidebar teardown
  if (this.element.id === 'Drawer' ) {
    this.element.dispatchEvent(new CustomEvent('sidebar-drawer:close', { bubbles: true }));
   
    if (opts.transparent && window.scrollY  <= 25) {
      document.querySelector('.header').classList.add('Header--Transparent');
    }
    document.body.querySelector('.header-hamburger-btn').classList.remove('is-active');
  } else if( this.breakpoint == 'desktop' || this.element.id === 'cart-drawer'){
    if (opts.transparent && window.scrollY <= 25) {
      document.querySelector('.header').classList.add('Header--Transparent');
    }
  }

  // 8) cart-drawer cleanup (if needed)
  if (this.element.id === 'cart-drawer') {
    const opts = JSON.parse(this.element.getAttribute('data-settings'));
    if (opts.showRecommendations) {
      setTimeout(() => {
        this.element.querySelector('.cart-drawer__recommendations').innerHTML = '';
      }, 800);
    }
  }

  // 9) collapse any dropdowns inside
  this.element.querySelectorAll('.Dropdown--Button').forEach(btn =>
    btn.setAttribute('aria-expanded', 'false')
  );
  this.element.querySelectorAll('.Dropdown--Content').forEach(el => {
    el.setAttribute('aria-hidden', 'true');
    el.style.height = 0;
  });

  // 10) remove focus trap & fire onClose
  removeTrapFocus(this.element);
  this.onClose();

  // 11) clear any inline sizing
  this.element.style.height = '';
  const contentEl = this.element.querySelector('.Drawer--Content');
  if (contentEl) {
    contentEl.style.maxHeight = '';
    contentEl.style.overflowY = '';
  }

  if (this._overlayObserver) {
  this._overlayObserver.disconnect();
  this._overlayObserver = null;
}
}

}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementScaleOut(elements) {
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;
    elements.forEach((element, index) => {
      if (element.hasAttribute("data-loaded")) {
        return;
      }
      element.setAttribute("data-loaded", true);
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];
      setTimeout(() => {
        element.animate(keyframes, {
          duration: animationDuration,
          fill: "forwards",
        });
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration * 2,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  // Simple fade-in animation without scaling
  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.hasAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { opacity: "0" },
          { opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const elements = [];
        results.forEach((result) => {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            elements.push(result.target);
            this.intersectionObserver[index].unobserve(result.target);
          }
        });
        if (elements.length === 0) {
          return;
        }
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut',
          elementFadeIn: 'elementFadeIn'
        };
        const method = animations[options.type];
        if (method) {
          this[method](elements);
        }
      },
      { threshold: 0.15 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }
    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}



if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options['noVariants'] == "true") {
      this.toggleAddButton();
    }
  }


  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
      addButtonInner = addButton.querySelector(".SelfAlign"),
      quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');
    if (quantityEl) {
      quantity = quantityEl.value();
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) { quantity = 1; }


    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='u-p3 ml-s'>" +
        Shopify.formatMoney(
          this.options['price'] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.innerHTML =
      buySvg + window.variantStrings.addToCart + priceElement;

  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }



    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;


    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);


var stateWasEmpty = true;
class cartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.focusElement = false;
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
        this.onClose();
      },
      onOpen: () => {
        this.isOpen = true;

        if (this.alreadyEntered == false) {
          this.onOpen();
        }
        this.alreadyEntered = true;
      },
    });
    this.loader = this.element.querySelector(".itemLoader");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.observeFooterResize();

    this.alreadyEntered = false;
    new AddToCart(this.element);
    this.loadRecommendations();


    this.bindEvents();
  }

  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));

      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".cart-item__quantity",
        this.updateItemQuantity.bind(this)
      );


      window.theme.listener = "true";
    }
  }

  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      setTimeout(() => {
        if (this.element.hasAttribute('data-open-drawer')) {
          bodyScrollLock.clearAllBodyScrollLocks();
          this.focusElement = this.element.querySelector("[data-scrollable]");
          bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
        }

      }, 500);

      if (this.options["showRecommendations"] && this.alreadyEntered == false) {
        requestAnimationFrame(() => {
          this.loadRecommendations();
        })
      }
    }
    const header = this.element.querySelector(".cart-drawer__header");
    const headerHeight = header.offsetHeight;

    document.documentElement.style.setProperty(
      "--cart-drawer__header-height",
      headerHeight + "px"
    );

  if (this.element.querySelector(".cart-drawer__footer")) {
    document.documentElement.style.setProperty(
      "--cart-drawer__footer-height",
      this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
    );
  }
  }

  updateFooterHeight() {
  const footer = this.element.querySelector(".cart-drawer__footer");
  if (footer) {
    document.documentElement.style.setProperty(
      "--cart-drawer__footer-height",
      `${footer.offsetHeight}px`
    );
  }
}
observeFooterResize() {
  const footer = this.element.querySelector(".cart-drawer__footer");
  if (!footer) return;

  this.footerResizeObserver = new ResizeObserver(() => {
    this.updateFooterHeight();
  });
  this.footerResizeObserver.observe(footer);
}
  onClose() {
    if (this.breakpoint == 'desktop' && this.recommendationContainer) {
      this.recommendationContainer.setAttribute("aria-expanded", "false");
      this.recommendationContainer = null;
    }
  }

  handleTransitionEnd(target) {
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    this.recommendationContainer.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();
    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    if (quantity === 0) {
      cartItem.classList.add("removing");
      const id = cartItem.dataset.id;
      if (this.cartIds) {
        this.cartIds = this.cartIds.filter((item) => item !== id);
      }

      const nextItem = cartItem.nextElementSibling;
      const height = cartItem.offsetHeight;
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      setTimeout(() => {
        cartItem.remove();
        if (!nextItem) {
          return;
        }
        nextItem.classList.add("repo--top");
        setTimeout(() => {
          nextItem.classList.remove("repo--top");
        }, 350);
      }, 350);
    }

    try {
      const response = await fetch(
        `${window.routes.localeRootUrl}/cart/change.js`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      }
      if (quantity == 0 && data.item_count > 0) {
        stateWasEmpty = true;
        if (this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
          this.renderCart(false, false, false, null, true);
          return;
        }
      }
      if (data.item_count > 0 && quantity > 0) {
        this.renderCart(target.getAttribute("data-id"), true);
      }

    } catch (error) {
      console.error("Failed to update item quantity:", error);
      // Optionally, show an error message to the user
    }
  }

  onProductAdded() {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }


    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute('data-open-drawer')) {
        if (this.isOpen == false) {

          this.isOpen = true;
          this.onOpen();
          this.alreadyEntered = true;
          this.drawer.openDrawer();

        }
      }
    });
  }

  renderCart(lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    this.pageLoader.style.width = 90 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );

      });
    });
  }

 replaceContent(html, lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    // 1) loader animation kickoff
    this.pageLoader.style.width = "100%";
    setTimeout(() => {
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";
      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);
    }, 100);

    // 2) parse new HTML
    const tempEl = document.createElement("div");
    tempEl.innerHTML = html;
     const iconCartFull = document.querySelector('.Svg--shopping_bag_filled');
     const iconCartEmpty = document.querySelector('.Svg--shopping_bag_default');

    // 3) grab new settings + cartIds
    this.options = JSON.parse(tempEl.querySelector("#cart-drawer").dataset.settings);
    if (tempEl.querySelector("[data-ids]")) {
      this.cartIds = tempEl
        .querySelector("[data-ids]")
        .dataset.ids.split(",")
        .filter((id) => id);
      if (updateCount) {
        this.cartIds = this.cartIds.filter((id) => id !== this.removeId);
        this.removeId = null;
        this.loadRecommendations();
      }
    }

    const itemCount = this.options.itemCount;
    window.theme.cartCount = Number(itemCount);

    const cartCountEl = document.querySelector('.header-cart__item-count');
    if (cartCountEl) {
      if (itemCount > 0) {
        cartCountEl.textContent = `(${itemCount})`;
        cartCountEl.classList.add('is-visible');
      } else {
        cartCountEl.textContent = '';
        cartCountEl.classList.remove('is-visible');
      }
    }

      // Cart icon toggle based on item count
  if (itemCount > 0) {
    if (iconCartFull) iconCartFull.style.display = 'block';
    if (iconCartEmpty) iconCartEmpty.style.display = 'none';
  } else {
    if (iconCartFull) iconCartFull.style.display = 'none';
    if (iconCartEmpty) iconCartEmpty.style.display = 'block';
  }

    // 4) SHORT-CIRCUIT: if cart is now empty, blow away the wrapper and stop.
    if (!updateCount && itemCount === 0) {
       this.replaceCartContent(tempEl);
        this.updateCartFooter(tempEl);
      this._hideLoaderWithDelay(200);
      this._syncLayoutHeightsAfter(100);
      stateWasEmpty = true;

       // ——— reload your empty-cart collection recommendations ———
    if (this.options.showRecommendations) {
      this.loadRecommendations();
    }
    
      return;
    }

    // 5) other flows:
    if (updateCount) {
      this.updateCartFooter(tempEl);
      stateWasEmpty = itemCount === 0;
      return;
    }

    if (lineNumber && tempEl.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(lineNumber, tempEl);
    } else if (productAdd && !stateWasEmpty && lineNumber) {
      this.addContent(tempEl, productAddEvent);
    } else {
      this.replaceCartContent(tempEl);
    }

    this.updateCartFooter(tempEl);

    this.element.dispatchEvent(new CustomEvent("cart:render", { bubbles: true }));
    stateWasEmpty = itemCount === 0;

    // 6) final tweaks after a beat
    setTimeout(() => {
      if (this.options.showRecommendations && !quantityChange && this.isOpen) {
        this.loadRecommendations();
      }
      if (this.element.hasAttribute("data-open-drawer")) {
        bodyScrollLock.clearAllBodyScrollLocks();
        this.focusElement = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
      }
    }, 200);

    
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info `
    );
    const oldCartItemInfo = cartItemParent.querySelector(`#${lineNumber} .cart-item__info`);


    if (!cartItemParent) {
      this.element
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.querySelector('.cart-item__inner').replaceChild(
        newCartItemInfo,
        oldCartItemInfo
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__wrapper").scrollTop = 0;
    }
    const itemToAdd = tempElement.querySelector(
      `#cart-item__${productAddEvent.variant}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");

        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }


 updateCartFooter(tempEl) {
  
    const { itemCount } = this.options;
    const wrapper = this.element.querySelector(".cart-drawer__wrapper");
    const curFooter = this.element.querySelector(".cart-drawer__footer");
    const newFooter = tempEl.querySelector(".cart-drawer__footer");

    // ★ toggle the "empty" class
  if (curFooter) {
    if (itemCount === 0) {
       const shippingSection = this.element.querySelector('.cart-drawer__shipping');
  if (shippingSection) shippingSection.remove();
      curFooter.classList.add("cart-drawer__empty");
    } else {
      curFooter.classList.remove("cart-drawer__empty");
    }
  }

    if (itemCount > 0) {
      // just added first item?
      if (!curFooter && newFooter) {
        wrapper.appendChild(newFooter);
        this.observeFooterResize();
      }
      this._updateTotals(tempEl);
      this._updateShippingProgress(tempEl);
    } else {
     
       this._updateTotals(tempEl);
         if (curFooter) curFooter.classList.add('cart-drawer__empty');
    }
    this._syncFooterHeight();
  }




  _updateTotals(tempElement) {
   
    const footerParent = document.querySelector('.cart-drawer__footer');
    const newTotals = tempElement.querySelector('.cart_drawer__footer-totals');
    const currentTotals = footerParent?.querySelector('.cart_drawer__footer-totals');
    if (!footerParent || !newTotals) return;

    if (currentTotals) {
      footerParent.replaceChild(newTotals, currentTotals);
    } else {
      footerParent.prepend(newTotals);
    }
  }

   _updateShippingProgress(tempElement) {
    const newBar = tempElement.querySelector('.cart-drawer__shipping-progress-bar');
    if (!newBar) return;

    const currentBar = document.querySelector('.cart-drawer__shipping-progress-bar');
    if (currentBar) {
      this._syncBar(currentBar, newBar);
    } else {
      this._attachShippingSection(tempElement);
    }
  }

   _syncBar(currentBar, newBar) {
    let percent = Math.min(Number(newBar.dataset.percent) || 0, 100);
    currentBar.dataset.percent = percent;
    currentBar.style.width = `${percent}%`;

    currentBar.classList.toggle('done', percent === 100);
    currentBar.classList.toggle('active', percent < 100);

    const newText = newBar.closest('.cart-drawer__shipping')
      ?.querySelector('.cart-drawer__shipping-text')
      .innerHTML;
    this.element.querySelector('.cart-drawer__shipping-text').innerHTML = newText;
  }

   _attachShippingSection(tempElement) {
    const header = this.element.querySelector('.cart-drawer__header');
    const shippingSection = tempElement.querySelector('.cart-drawer__shipping');
    if (header && shippingSection) {
      header.appendChild(shippingSection);
    }
  }

   _syncFooterHeight() {
    const footer = this.element.querySelector('.cart-drawer__footer');
    if (!footer) return;

    const height = footer.offsetHeight;
    document.documentElement.style.setProperty(
      '--cart-drawer__footer-height',
      `${height}px`
    );
  }
  clearCartFooter(tempElement) {

    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (document.querySelector(".cart-drawer__footer")) {
      document
        .querySelector(".cart-drawer__footer")
        .classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        ".cart-drawer__wrapper"
      ).innerHTML;
    }
  }


  replaceCartContent(tempElement) {
    this._cacheWrapperState();
    this._swapWrapper(tempElement);
     this.updateCartFooter(tempElement);
    this._hideLoaderWithDelay(200);
    this._restoreScrollPosition();
    this._syncLayoutHeightsAfter(100);
  }

  // --- Private helpers for replaceCartContent ---

  _cacheWrapperState() {
    const wrapper = this.element.querySelector('.cart-drawer__wrapper');
    this._wrapperParent = wrapper.parentNode;
    this._savedScrollTop = wrapper.scrollTop;
  }

  _swapWrapper(tempElement) {
    
      const newContent = tempElement.querySelector('.cart-drawer__content');
      const oldContent = this.element.querySelector('.cart-drawer__content');
      if (newContent && oldContent) oldContent.replaceWith(newContent);

      const newRecs = tempElement.querySelector('.cart-drawer__recommendations');
      const oldRecs = this.element.querySelector('.cart-drawer__recommendations');
      if (newRecs && oldRecs) oldRecs.replaceWith(newRecs);

  }

  _hideLoaderWithDelay(delayMs) {
    setTimeout(() => {
      this.loader?.classList.remove('is-visible');
    }, delayMs);
  }

  _restoreScrollPosition() {
    const wrapper = this.element.querySelector('.cart-drawer__wrapper');
    if (wrapper) wrapper.scrollTop = this._savedScrollTop;
  }

  _syncLayoutHeightsAfter(delayMs) {
    setTimeout(() => {
      this._updateHeaderHeight();
      this._updateFooterHeight();
    }, delayMs);
  }

  // --- Private helpers for syncing heights ---

  _updateHeaderHeight() {
    const header = this.element.querySelector('.cart-drawer__header');
    if (!header) return;

    const height = header.offsetHeight;
    document.documentElement.style.setProperty(
      '--cart-drawer__header-height',
      `${height}px`
    );
  }

  _updateFooterHeight() {
   const footer = this.element.querySelector('.cart-drawer__footer');
    if (!footer) return;

    const height = footer.offsetHeight;
    document.documentElement.style.setProperty(
      '--cart-drawer__footer-height',
      `${height}px`
    );
  }

  loadRecommendations() {
    this.recommendationLoading = true;
    let recommendationsContainer = this.element.querySelector(
      ".cart-drawer__recommendations"
    );

    if (!recommendationsContainer) return;
    const productId = this.options["productId"];

    const baseUrl = window.routes.localeRootUrl;
    let url;

    // Determine the URL based on whether a product ID is present
    if (!productId) {
      url = "?section_id=helper-recommendations";
    } else {
      let limit = this.element.getAttribute("product-limit");
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&l${limit}&intent=${this.options["intent"]}`;
    }

    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;

        let recommendedIds = null;
        if (container.querySelector(".cart-drawer__rec-item")) {
          recommendedIds = [
            ...container.querySelectorAll(".cart-drawer__rec-item"),
          ].map((item) => item.dataset.id);
        }

        if (!recommendedIds) {
          recommendationsContainer.style.display = 'none';
        } else {
          recommendationsContainer.style.display = 'block';
        }

        if (!this.cartIds) {
          if (recommendationsContainer.dataset.ids) {
            this.cartIds = recommendationsContainer.dataset.ids
              .split(",")
              .filter((item) => item !== "");
          }
        }

        if (this.cartIds && recommendedIds) {
          const hasCommonItem = this.cartIds.some((item) =>
            recommendedIds.includes(item)
          );
          if (hasCommonItem) {
            return;
          }
        }

        let recommendationsHTML = container.querySelector(
          ".cart-drawer__upsell"
        )?.innerHTML;

        if (recommendationsHTML) {
          recommendationsContainer.innerHTML = recommendationsHTML;
          this.initializeSwiper();
          new AddToCart(this.element);
        }
      })
      .catch((error) => {
        console.error("Failed to load recommendations:", error);
      });
  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

  initializeSwiper() {
    new Swiper(".swiperUpsell", {
      slidesPerView: 1.5,
      spaceBetween: 12,
      pagination: {
        el: "#cart-drawer__swiper-pagination",
        type: "bullets",
        clickable: true,
        spaceBetween: 16,
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active"
      },
      navigation: {
            nextEl: ".swiperButtonNext",
            prevEl: ".swiperButtonPrevious"
        },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1025: {
          slidesPerView: 1.183,
          spaceBetween: 24,
        },
      },
    });

    // Check how many slides exist to hide navigation buttons
    const slides = this.element.querySelectorAll('.swiperUpsell .swiper-slide');
    const navWrapper = this.element.querySelector('.recommendations__navigation-wrapper');
    if (navWrapper) {
      if (slides.length < 2) {
        navWrapper.style.display = 'none';
      } else {
        navWrapper.style.display = '';
      }
    }
  }

}
if (window.theme.cartMode === 'drawer' && !customElements.get('cart-drawer')) {
  customElements.define("cart-drawer", cartDrawer);
}

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.carousel = new RevolutionSwiper(this.carouselElement);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}

customElements.define("featured-collection", FeaturedCollectionSection);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateBody = new Delegate(document.body);
    new RevolutionAnimation(this.element);
    new RevolutionSwiper(this.querySelector(".swiper"));
    new AddToCart(this.element)
  }

  connectedCallback() {
    this.delegateBody.on('recommendations:reload', this.reloadRecommendations.bind(this));
    this.loadRecommendations(this.dataset.url);

  }

  reloadRecommendations(e) {
    const productId = e.detail;
    const url = this.dataset.urlTemplate.replace("PRODUCT_ID", productId);
    this.loadRecommendations(url);
  }

  async loadRecommendations(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();

      const html = new DOMParser().parseFromString(text, "text/html");

      const newSwiper = html.querySelector(".product-recommendations__swiper");
      const oldSwiper = this.element.querySelector(".product-recommendations__swiper");

      oldSwiper.swiper.destroy();

      if (newSwiper) {
        oldSwiper.parentElement.replaceChild(newSwiper, oldSwiper);
        new RevolutionAnimation(this.element);

        const productCards = newSwiper.querySelectorAll(".featured-collection__cell");
        const productCount = productCards.length;

        const isDesktop = responsive.matchesBreakpoint("lap_and_up");
        const hideButtons = (isDesktop && productCount < 4) || (!isDesktop && productCount < 2);

        if (hideButtons) {
          this.applyGridFallbackLayout(productCards, isDesktop);
        } else {
          new RevolutionSwiper(newSwiper);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  applyGridFallbackLayout(productCards, isDesktop) {
    this.element.querySelector('.featured-collection__carousel--controls')?.style.setProperty('display', 'none');

    const wrapper = this.element.querySelector('.featured-collection__swiper-wrapper');
    if (!wrapper) return;

    wrapper.style.display = 'grid';
    wrapper.style.gridTemplateColumns = isDesktop ? '1fr 1fr 1fr' : '1fr';
    wrapper.style.gap = '1.5rem';

    const header = this.element.querySelector('.featured-collection__header');
    if (header) {
      const leftPadding = getComputedStyle(header).paddingLeft;
      wrapper.style.paddingLeft = leftPadding;
      wrapper.style.paddingRight = leftPadding;
      wrapper.style.width = 'unset';

      productCards.forEach(card => {
        card.style.width = '100%';
      });
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.responsive = new Responsive();
    this.breakpoint = responsive.getCurrentBreakpoint();

    this.prepareCollection();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-collection"]',
      (event) => {
        if (this.breakpoint === 'pocket' || this.breakpoint === 'phone') {
          this.toggleCollection(event);
        }
      }
    );

    this.delegateElement.on(
      "mouseover",
      '[data-action="toggle-collection"]',
      (event) => {
        if (this.breakpoint === 'desktop') {
          this.toggleCollection(event);
        }
      }
    );
  }

  prepareCollection() {
    const firstCollectionImage = this.element.querySelector(".collection-showcase__image-container");
    const firstCollectionContentBlock = this.element.querySelector(".collection-showcase__content-block");
    const firstCollectionContentBlockDesktop = this.element.querySelector(".collection-showcase__content-block-desktop");
    const firstCollectionTab = this.element.querySelector(".collection-showcase__tab");

    firstCollectionImage.style.display = "flex";
    if(firstCollectionContentBlock) firstCollectionContentBlock.style.display = "flex";
    if(firstCollectionContentBlockDesktop) firstCollectionContentBlockDesktop.style.display = "flex";

    firstCollectionTab.classList.add("active");
  }

  toggleCollection(event) {
    const tab = event.target.closest(".collection-showcase__tab");
    if (!tab) return;

    const targetId = tab.getAttribute("id");

    const collectionImages = this.element.querySelectorAll(".collection-showcase__image-container");
    const collectionContentBlocks = this.element.querySelectorAll(".collection-showcase__content-block");
    const collectionContentBlocksDesktop = this.element.querySelectorAll(".collection-showcase__content-block-desktop");
    const collectionTabs = this.element.querySelectorAll(".collection-showcase__tab");

    const toggleVisibility = (elements) => {
        elements.forEach(el => el.style.display = el.getAttribute("id") === targetId ? "flex" : "none");
    };

    toggleVisibility(collectionImages);

    if (this.breakpoint === "pocket" || this.breakpoint === "phone") {
        toggleVisibility(collectionContentBlocks);
    } else if (this.breakpoint === "desktop") {
        toggleVisibility(collectionContentBlocksDesktop);
    }

    collectionTabs.forEach(t => t.classList.toggle("active", t === tab));
}

}

customElements.define("collection-showcase", CollectionShowcase);


class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}
customElements.define("slider-text", SliderTextSection);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.headerTransparent = false;
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.options.sticky) {
      this.toggleSticky();
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    this.updateVisibleHeight();
    window.onload = () => setTimeout(() => this.updateVisibleHeight(), 500);
    this.bindEvents();
    this.menuOverlapHandler();
  }



  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".header-menu-items"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".header--Wrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".header-main-links");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    document.documentElement.style.setProperty(
      "--header-height",
      _this.element.clientHeight + "px"
    );
    menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
  }

  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function () {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    // window.addEventListener("resize", this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);

    if (this.options.transparent || this.options.sticky) {
      this.toggleColorListener = this.toggleColor.bind(this);
      scrollListener.addScrollListener(this, this.toggleColorListener);
    }

    window.addEventListener("scroll", this.toggleColorListener);
    window.addEventListener("scroll", this.toggleTopBarListener);

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this),
      true
    );
    
 

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .header-main-links",
      this.closeMenu.bind(this),
      true
    ); 
   this.delegateElement.on(
  "click",
  ".menu-item-card.has-child",
  this.openThirdMenu.bind(this),
  true
);

    this.delegateElement.on(
        "click",
        '[data-action="back-button"]',
        (ev) => {
         
          this.closeThirdMenu(ev);
        },
        true
    )

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    // window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }

  closeThirdMenu(ev){
    ev.preventDefault();
    ev.stopPropagation();

    console.log('hereee');
    const backButton = ev.target.closest('.menu-item-card__back-btn');
    const thirdLevelMenu = backButton.closest('.desktop-menu__third-lvl');
    
    if (thirdLevelMenu) {
      thirdLevelMenu.setAttribute("aria-hidden", "true");
    }
  }
 openThirdMenu(ev, target) {
  ev.preventDefault();
  ev.stopPropagation();

  // only proceed if this really is a "has-child" opener
  const targetId = target.getAttribute("aria-trigger");
  if (!targetId) return;

  const targetEl = this.element.querySelector(`#${targetId}`);
  if (!targetEl) {
    console.warn(`openThirdMenu: no element found for #${targetId}`);
    return;
  }

  // show it
  targetEl.setAttribute("aria-hidden", "false");
}

  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate the visible height
      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);


      // Ensure the visibleHeight is never negative
      visibleHeight = Math.max(visibleHeight, 0);
      // Update the height of header with the visible height
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `${visibleHeight}px`
      );

      document.documentElement.style.setProperty(
        "--header-height-fixed",
        document.querySelector("#header").offsetHeight + "px"
      );
    }, 550);

  }
  toggleTopBar() {
    let current = window.scrollY;
    let annBar = document.querySelector(".announcement-bar");
    let element_height = this.element.offsetHeight;

    if ((element_height + annBar.offsetHeight) * 2 < current) {
      this.element.parentElement.classList.add("header--fixed-top-bar");
    }

    if (current <= annBar.offsetHeight) {
      this.element.parentElement.classList.remove("header--fixed-top-bar");
    }

    if (
      this.prevOffset < current &&
      current >= annBar.offsetHeight + this.element.offsetHeight
    ) {
      this.element.parentElement.classList.add("header--hide");
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `0px`
      );
    } else {
      this.element.parentElement.classList.remove("header--hide");
      this.updateVisibleHeight();
    }

    this.prevOffset = current;
  }
  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",

      `${document.querySelector("#header").offsetHeight}px`
    );
  }

  openMenu(event, target) {
    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach((item) => {
      if(item !== target) {
        item.setAttribute("aria-expanded", "false");
      }
    })
    // Dispatch a custom event to indicate that the menu is being opened.

    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);

    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }

    target.setAttribute("aria-expanded", "true");
    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(
      this.scrollableElement,
      bodyScrollLockOptions
    );
  }

  closeMenu(event, target) {
    if (event.type === "mouseleave" && target !== event.target) {
      return;
    }

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
      item.setAttribute("aria-expanded", "false");
    });
    const thirdMenu = document.querySelectorAll(".desktop-menu__third-lvl");

    thirdMenu.forEach((item) => {
      item.setAttribute("aria-hidden", "true");
    })

    bodyScrollLock.enableBodyScroll(this.scrollableElement);
  }

  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add("Header--Scrolled");
    } else {
      this.element.classList.remove("Header--Scrolled");
    }
    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }
}
customElements.define("header-component", Header);

// In this rewrite, we treat "third-level" submenus as just another submenu, 
// using the same logic and handler for all submenu levels. 
// The openSubmenu method is now generic and can open any submenu, regardless of depth.

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.SidebarMenu = new Drawer(this.element);
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".MenuSlideshowMobile");

    this.bindEvents();
  }

  bindEvents() {
    // submenu open
    this.delegateElement.on(
      "click",
      "[data-action='toggle-submenu'], .menu-item-card",
      this.openSubmenu.bind(this),
      true
    );

    // back button
    this.delegateElement.on("click", "[data-action='back']", this.backToParent.bind(this));

    // when drawer opens: adjust overlays, footer
    this.delegateBody.on("sidebar-drawer:open", () => {
      this.onDrawerListener();
      this.computeFooterHeight();
    });

    // when drawer closes: reset all submenus
    this.delegateBody.on("sidebar-drawer:close", () => {
      this.resetSubmenus();
    });
  }

  computeFooterHeight() {
    const footer = this.element.querySelector(".main-menu__footer");
    if (footer) {
      document.documentElement.style.setProperty(
        "--mob-menu-footer-dynamic",
        `${footer.offsetHeight}px`
      );
    } else {
      document.documentElement.style.removeProperty("--mob-menu-footer-dynamic");
    }
  }

  /**
   * Close all open submenu drawers and reset them to initial hidden state.
   */
  resetSubmenus() {
    // find all submenu wrappers
    const subs = this.element.querySelectorAll(".main-menu__submenu-wrapper");
    subs.forEach(submenu => {
      // hide immediately
      submenu.style.display = "none";
      submenu.setAttribute("aria-hidden", "true");
      // clean up any inline transition handlers
      submenu.removeEventListener("transitionend", submenu._closeListener);
    });
  }

  /**
   * Closes the parent submenu when a 'back' button is clicked.
   */
  backToParent(ev, target) {
    const parentSubmenu = target.closest(".main-menu__submenu-wrapper");
    if (!parentSubmenu) return;

    // once transition ends, actually hide
    const onTransitionEnd = () => {
      bodyScrollLock.disableBodyScroll(parentSubmenu.querySelector("[data-scrollable]"), bodyScrollLockOptions);
      parentSubmenu.style.display = "none";
    };

    // save listener so we can clean up on reset
    parentSubmenu._closeListener = onTransitionEnd;
    parentSubmenu.addEventListener("transitionend", onTransitionEnd, { once: true });

    parentSubmenu.setAttribute("aria-hidden", "true");
  }

  /**
   * Opens a submenu (second-level, third-level, etc.).
   */
  openSubmenu(ev, target) {
    let submenu = null;
    const triggerId = target.getAttribute("aria-trigger");
    if (triggerId) {
      submenu = this.element.querySelector(`#${triggerId}`);
    } else {
      const menuItem = target.closest(".main-menu__menu-item");
      submenu = menuItem?.nextElementSibling;
    }

    if (submenu?.classList.contains("main-menu__submenu-wrapper")) {
      submenu.style.display = "block";
      bodyScrollLock.disableBodyScroll(submenu.querySelector("[data-scrollable]"), bodyScrollLockOptions);
      requestAnimationFrame(() => {
        submenu.setAttribute("aria-hidden", "false");
      });
    }
  }

  onDrawerListener() {
    this.pageOverlay = document.querySelector(".pageOverlay");
    this.locOverlay = document.querySelector(".localizationOverlay");
    if (this.pageOverlay) this.pageOverlay.classList.remove("is-visible");
    if (this.locOverlay) this.locOverlay.classList.remove("is-visible");
  }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);


class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {

      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();


class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";


    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: true,
      // muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,


      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;

    this.videoPlayer.on("click", function (event) {
      const clickedInsideControls = event.target.closest(".vjs-control-bar");
      if (!clickedInsideControls) {
        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      }
    });
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }

      _this.bindCustomControls();
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  bindCustomControls() {
    this.stateElements = this.element.querySelectorAll("[data-action='toggle-state']");
    this.soundElements = this.element.querySelectorAll("[data-action='toggle-sound']");

    if (!this.stateElements.length || !this.soundElements.length) return;

    this.delegateElement.on("click", "[data-action='toggle-state']", () => {
        this.videoPlayer.paused() ? this.videoPlayer.play() : this.videoPlayer.pause();
    });

    this.delegateElement.on("click", "[data-action='toggle-sound']", () => {
        this.videoPlayer.muted() ? this.videoPlayer.muted(false) : this.videoPlayer.muted(true);
    });

    this.videoPlayer.on("play", () => {
        this.stateElements.forEach(el => el.setAttribute("aria-label", "playing"));
    });

    this.videoPlayer.on("pause", () => {
        this.stateElements.forEach(el => el.setAttribute("aria-label", "paused"));
    });

    this.videoPlayer.on("volumechange", () => {
        this.soundElements.forEach(el => el.setAttribute("aria-label", this.videoPlayer.muted() ? "muted" : "unmuted"));
    });

    if (!this.options["muted"] && this.options["autoplay"]) {
      const unmuteOnInteraction = () => {
        this.videoPlayer.muted(false);
        document.removeEventListener("click", unmuteOnInteraction);
        document.removeEventListener("touchstart", unmuteOnInteraction);
      };

      document.addEventListener("click", unmuteOnInteraction, { once: true });
      document.addEventListener("touchstart", unmuteOnInteraction, { once: true });
    }
}


  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.footer = document.querySelector(".main-footer");
    this.domDelegate = new Delegate(this.element);

    this.submitBtn = this.footer.querySelector(".footer__newsletter-submit-button");

    this.term = this.footer.querySelector("#newsletter-agree");

    if(this.term && !this.term.checked){
      this.submitBtn.style.pointerEvents = "none";
    }

  this.bindEvents()
  }

  connectedCallback() {
    document.documentElement.style.setProperty(
      "--footer-dynamic-height",
      this.footer.offsetHeight + "px"
    );
    window.addEventListener("load", () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.footer.offsetHeight + "px"
      );
    });
    responsive.addResizeListener(this, () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.footer.offsetHeight + "px"
      );
    });
  }


  bindEvents(){
    this.domDelegate.on("change", "#newsletter-agree", this.handleCheck.bind(this));
  }

  handleCheck(ev){

    if(!ev.target.checked){
      this.submitBtn.style.pointerEvents = "none";
    }
    else{
      this.submitBtn.style = "";
    }
  }
}
customElements.define("footer-component", FooterComponent);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    this.changeImageQuality();
    new AddToCart(this.element);
  }

  connectedCallback() {
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(".ProductSlider--Thumbnails");
    this.uspSwiperElement = this.element.querySelector(".product-usp__swiper.swiper");

    this.tintElement = this.element.querySelector('.ProductSlider--Tint');
    this.wrapperElement = this.element.querySelector('.ProductSlider--Wrapper');
    this.productInfoWrapper = document.querySelector('.product-info__wrapper');
    this.mainAtc = this.element.querySelector(".product-info__actions");
    this.valuesWrap = this.element.querySelectorAll(".ProductOption--ValusWrapper");

    const slides = this.carouselElement?.querySelectorAll('.swiper-slide') || [];

    if (slides.length > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement, this.carouselElementThumbs);
    } else {
      const buttons = this.element.querySelectorAll('.pdp_swiperButton');
      buttons.forEach(btn => btn.style.display = 'none');
    }

    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    if (this.uspSwiperElement) {
      this.uspSwiper = new RevolutionSwiper(this.uspSwiperElement);
    }

    if (this.options["sticky_atc"]) {
      this.stickyAtcWrapper = this.element.querySelector(".pdp-sticky-product-atc");
      document.body.classList.add('has-sticky');
    } else {
      document.body.classList.remove('has-sticky');
    }

    this.bindEvents();
    this.initScrollTintObserver();
    this.appendPriceSpans();

    requestAnimationFrame(() => {
      setTimeout(() => this.syncThumbnailHeight(), 100);
    });

    responsive.addResizeListener(this, this.syncThumbnailHeight);
    this.updatePriceButtonATC();

    document.addEventListener("variant:price-updated", () => {
      this.updatePriceButtonATC();
    });
  }

  // Bind event listeners for DOM events
  bindEvents() {
    this.domDelegate.on(
      "click",
      ".pdp-connected-product-card",
      this.selectConnectedProductCard.bind(this)
    );

    this.domDelegate.on("click", e => {
    const target = e.target;

    if (
      target.closest(".pdp-addon-product-card") ||
      target.matches("input.pdp-addon-product-card__checkbox") ||
      target.matches("input.pdp-accessory-product-card__checkbox") ||
      target.matches("label.SelectboxCircle") ||
      target.matches("div.Selectbox") ||
      target.matches("button.quantity-btn") ||
      target.matches("label.SelectboxLabelNormal")
    ) {
      this.updatePriceButtonATC();
    }
  });

    this.domDelegate.on("variant:changed", this.updateImage.bind(this));

    if (this.stickyAtcWrapper) {
      scrollListener.addScrollListener(this, this.showStickyAtc.bind(this));
    }
    // Sticky Add to Cart functionality
    if (this.options["sticky_atc"] && this.stickyAtcWrapper) {
      this.delegateBody.on("product:added", this.hideStickyTimeout.bind(this));
      this.delegateBody.on("product:error", this.hideStickyTimeout.bind(this));
      window.addEventListener(
        "DOMContentLoaded",
        this.showStickyAtc.bind(this)
      );
    }
  }


  updateImage(event) {
    let imageID = this.options.variant_image_id;
    if (event?.detail?.new_image) {
      imageID = event.detail.new_image;
    }
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);
    if (!imageEl) return;

    const slideElement = imageEl.closest('.swiper-slide');
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(slideElement);

    this.carousel.selectCell(realIndex);
  }

  syncThumbnailHeight() {
    const mainSwiper = this.element.querySelector('.swiper.mainSwiper');
    const thumbnailsSwiper = this.element.querySelector('.ProductSlider--Thumbnails.swiper');

    if (!mainSwiper || !thumbnailsSwiper) return;

    const height = mainSwiper.offsetHeight;
    thumbnailsSwiper.style.maxHeight = `${height}px`;
  }

  initScrollTintObserver() {
    if (!this.wrapperElement || !this.tintElement || !this.productInfoWrapper) return;

    window.addEventListener('scroll', this.updateTintOpacity.bind(this));
    window.addEventListener('resize', this.updateTintOpacity.bind(this));

    this.updateTintOpacity(); // Initial call
  }

  selectConnectedProductCard(event) {
    const clickedCard = event.target.closest(".pdp-connected-product-card");
    if (!clickedCard) return;

    const allCards = this.element.querySelectorAll(".pdp-connected-product-card");
    allCards.forEach(card => card.classList.remove("pdp-connected-product-card--selected"));

    clickedCard.classList.add("pdp-connected-product-card--selected");
  }

  updateTintOpacity() {
    const wrapperRect = this.wrapperElement.getBoundingClientRect();
    const infoRect = this.productInfoWrapper.getBoundingClientRect();

    const overlapTop = Math.max(wrapperRect.top, infoRect.top);
    const overlapBottom = Math.min(wrapperRect.bottom, infoRect.bottom);
    const overlapHeight = Math.max(0, overlapBottom - overlapTop);

    const wrapperHeight = wrapperRect.height;
    const overlapRatio = Math.min(overlapHeight / wrapperHeight, 1);

    // Map 0.5+ overlap to opacity 1, and 0 to 0.
    const scaledOpacity = Math.max(0, Math.min(overlapRatio * 2, 1)); // doubles ratio, clamps to 1

    this.tintElement.style.opacity = scaledOpacity.toFixed(2);
  }

  calculateTotalPrice() {
    let total = 0;

    // Main product price
    const mainPriceEl = this.element.querySelector('[data-price].product-info__price--value');
    if (mainPriceEl) {
      const price = parseFloat(mainPriceEl.getAttribute("data-price"));
      total += isNaN(price) ? 0 : price;
    }

    // Add-ons
    const checkedAddons = this.element.querySelectorAll('.pdp-addon-product-card__checkbox:checked[data-price]');
    checkedAddons.forEach(input => {
      const price = parseFloat(input.getAttribute("data-price")) || 0;
      total += price;
    });

    // Accessories
    const checkedAccessories = this.element.querySelectorAll('.pdp-accessory-product-card__checkbox:checked[data-price]');
    checkedAccessories.forEach(input => {
      const price = parseFloat(input.getAttribute("data-price")) || 0;
      const productId = input.getAttribute("data-productid");
      const qtyInput = this.element.querySelector(`.quantity-input[data-productid="${productId}"]`);
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      total += price * qty;
    });

    return total;
  }

  appendPriceSpans() {
    this.element.querySelectorAll(".product__atc-button").forEach(button => {
      if (button.hasAttribute("disabled")) return;
      if (button.querySelector('.button-total-price')) return;

      const span = document.createElement("span");
      span.className = "ButtonText button-total-price u-pb1";
      span.setAttribute("data-money-convertible", "");

      const total = this.calculateTotalPrice();
      span.textContent = ` - ${Shopify.formatMoney(total, window.theme.moneyFormat)}`;

      button.insertBefore(span, button.children[1] || null);
    });
  }

  updatePriceButtonATC() {
    const total = this.calculateTotalPrice(); // in cents
    const formatted = Shopify.formatMoney(total, window.theme.moneyFormat);

    this.element.querySelectorAll(".product__atc-button .button-total-price").forEach(span => {
      const button = span.closest(".product__atc-button");
      if (button && button.hasAttribute("disabled")) return;

      span.textContent = ` - ${formatted}`;
    });
  }

  // Hide the sticky Add to Cart button with a timeout
  hideStickyTimeout() {
    this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
    this.hideSticky = true;
    setTimeout(() => {
      this.hideSticky = false;
      this.showStickyAtc();
    }, 3000);
  }

  // Show the sticky Add to Cart button based on scroll position
  showStickyAtc() {
    if (this.hideSticky || !this.stickyAtcWrapper) return;

    const options = {
      root: null,
      threshold: 0,
    };

    // Get footer height and check if it's visible
    const footer = document.querySelector("footer");
    const footerHeight = footer.offsetHeight;

    const checkFooterVisibility = () => {
      return window.innerHeight + window.scrollY >= document.body.offsetHeight - footerHeight;
    };

    // Observer for the main ATC button
    const atcObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.mainAtcVisible = true;
          this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
          document.body.classList.remove("has-sticky");
        } else {
          this.mainAtcVisible = false;
          if (!this.footerVisible) {
            this.stickyAtcWrapper.setAttribute("aria-hidden", "false");
            document.body.classList.add("has-sticky");
          }
        }
      });
    }, options);

    // Observer for the footer to track visibility
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.footerVisible = entry.isIntersecting;

        if (this.footerVisible) {
          this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
          document.body.classList.remove("has-sticky");
        } else if (!this.mainAtcVisible) {
          this.stickyAtcWrapper.setAttribute("aria-hidden", "false");
          document.body.classList.add("has-sticky");
        }
      });
    }, options);

    // Initial check in case the page loads with the footer already visible
    this.footerVisible = checkFooterVisibility();

    if (this.footerVisible) {
      this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
      document.body.classList.remove("has-sticky");
    } else {
      atcObserver.observe(this.mainAtc);
      footerObserver.observe(footer);
    }
  }

  // Change image quality to high resolution
  changeImageQuality() {
    const imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}

// Define the custom element
customElements.define("product-component", ProductElement);

class VariantSelectBox extends HTMLElement {
  constructor() {
    super();
    this.element = this; // reference to our element
  }

  connectedCallback() {
    // Keep this minimal: just init, observe resize, bind events, do initial layout
    this.observeResize();
    this.bindEvents();
    this.calculateLayout();
  }

  /**
   * If you have a custom responsive utility, use that;
   * otherwise, fall back to window resize
   */
  observeResize() {
    if (typeof responsive !== "undefined" && responsive.addResizeListener) {
      responsive.addResizeListener(this, this.handleResize.bind(this));
    } else {
      window.addEventListener("resize", this.handleResize.bind(this));
    }
  }

  /**
   * Use your original approach (Delegate) to bind show-more / show-less
   */
  bindEvents() {
    // We attach delegate to the wrapper (or this.element) - your choice
    this.delegateElement = new Delegate(this.selectBoxWrapper);

    // Show more
    this.delegateElement.on(
      "click",
      '[data-action="show-more"]',
      this.showAllVariants.bind(this)
    );

    // Show less
    this.delegateElement.on(
      "click",
      '[data-action="show-less"]',
      this.showLessVariants.bind(this)
    );
  }

  /**
   * Main layout logic: measure how many variants fit in one row,
   * ensuring the + x more button (if needed) is also in the same row.
   */
  calculateLayout() {
    if (!this.selectBoxWrapper) return;

    // Temporarily show everything so we can measure
    this.variants.forEach((variant) => {
      variant.style.display = ""; // revert to default (inline-block/flex)
    });
    // Show plus, hide minus for measurement
    if (this.plusButton) this.plusButton.style.display = "";
    if (this.minusButton) this.minusButton.style.display = "none";

    const availableWidth = this.selectBoxWrapper.offsetWidth;
    if (!availableWidth) return;

    // If no variants, just hide plus/minus
    if (this.totalVariants === 0) {
      if (this.plusButton) this.plusButton.style.display = "none";
      if (this.minusButton) this.minusButton.style.display = "none";
      return;
    }

    // Measure a single variant's width (use first variant as a reference)
    const singleVariantWidth = this.variants[0].offsetWidth;
    // Gap (if you have margin, measure it via getComputedStyle; here we assume 4px)
    const variantGap = 8;

    // Measure plus button width
    const plusButtonWidth = this.plusButton ? this.plusButton.offsetWidth : 0;
    let itemsInFirstRow = 0;
    let totalWidthSoFar = 0;

    // Figure out how many variants we can fit in one row
    for (let i = 0; i < this.variants.length; i++) {
      // Width for this variant (plus gap if it's not the first)
      const widthNeeded = variantGap + singleVariantWidth;

      // If there's another variant *after* this one,
      // we must reserve space for the plus button in THIS row.
      const stillMoreVariantsRemain = (i < this.variants.length - 1);
      const spaceNeededForPlus = stillMoreVariantsRemain ? plusButtonWidth : 0;


      // Check if this variant + plus button (if more remain) fits
      if (totalWidthSoFar + widthNeeded + spaceNeededForPlus <= availableWidth) {
        itemsInFirstRow++;
        totalWidthSoFar += widthNeeded;

      } else {
        // As soon as we can't fit the next variant + button, we stop
        break;
      }
    }

    // If all variants fit, hide plus/minus
    if (itemsInFirstRow >= this.totalVariants) {
      // Show all
      this.variants.forEach((variant) => {
        variant.style.display = "";
      });
      if (this.plusButton) this.plusButton.style.display = "none";
      if (this.minusButton) this.minusButton.style.display = "none";
    } else {
      // We show only itemsInFirstRow
      this.variants.forEach((variant, idx) => {
        variant.style.display = idx < itemsInFirstRow ? "" : "none";
      });

      // Show plus button with the correct count
      if (this.plusButton) {
        this.remaining = this.totalVariants - itemsInFirstRow;
        this.plusButton.style.display = "";
        this.plusButton.innerText = `+ ${this.remaining} more`;
      }
      // Hide minus button initially
      if (this.minusButton) {
        this.minusButton.style.display = "none";
      }
    }
  }

  handleResize() {
    this.calculateLayout();
  }

  /**
   * Show all items, hide plus button, show minus button
   */
  showAllVariants(event, target) {
    // Show all variants
    this.variants.forEach((variant) => {
      variant.style.display = "";
    });
    // Hide plus button
    if (this.plusButton) {
      this.plusButton.style.display = "none";
    }
    // Show minus with updated text
    if (this.minusButton) {
      this.minusButton.innerText = `- ${this.remaining} less`;
      this.minusButton.style.display = "";
    }
  }

  /**
   * Collapse items back to what fits in one row
   */
  showLessVariants(event, target) {
    this.calculateLayout();
  }
}

customElements.define("variant-selectbox", VariantSelectBox);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.atcButtons = document.querySelectorAll(".product__atc-button");
    this.stickyAtcWrapper = document.querySelector(".pdp-sticky-product-atc");
    this.notifyButtons = document.querySelectorAll(
      ".product-module__product-atc-notify"
    );

    this.notifyStickyAddButton = document.querySelector(
      ".product-module__product-atc"
    );

    this.regularPrice = document.querySelector(
      "product-component .product-info__price--regular span"
    );
    this.compareAtPrice = document.querySelector(
      "product-component .product-info__price--compare"
    );

    this.regularPriceSticky = document.querySelector(".product-module__sticky-atc product-info__price--regular span");
    this.compareAtPriceSticky = document.querySelector(".product-module__sticky-atc .product-info__price--compare");

    this.pricesWrapper = document.querySelector(
      ".product-info__price"
    );



    this.bindEvents();
  }

  bindEvents() {
    this.onVariantChange();

    this.delegateElement.on('change', 'select, input', this.onVariantChange.bind(this));
    this.delegateBody.on('click', '[data-action="click-atc"]', this.clickAtc.bind(this));
    this.delegateElement.on('click', '.quantity-btn.increase, .quantity-btn.decrease', () => {
      this.initAccessoryStateSync();
    });
  }

  clickAtc(event) {
    event.preventDefault();
    document.querySelector('.product-info__actions .product__atc-button').click();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    this.toggleAddButton();
    this.updateAvailability();
    this.updatePriceElements(this.regularPrice, this.compareAtPrice);
    if (this.stickyAtcWrapper) this.updatePriceElements(this.regularPriceSticky, this.compareAtPriceSticky);
    document.dispatchEvent(new CustomEvent("variant:price-updated"));
    this.updateLowestPrice();
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateAvailability() {
    let availableSuccessDiv = document.querySelector(".availability-success__wrapper");
    let availableErrorDiv = document.querySelector(".availability-error__wrapper")

    this.currentVariant = this.updateMasterId();

    if (this.currentVariant.available) {
      availableSuccessDiv.setAttribute("aria-hidden", false);
      availableErrorDiv.setAttribute("aria-hidden", true);
    } else {
      availableSuccessDiv.setAttribute("aria-hidden", true);
      availableErrorDiv.setAttribute("aria-hidden", false);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    return this.currentVariant;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updatePriceElements(regularPriceElement, compareAtPriceElement) {
    if (regularPriceElement) {
      this.regularPriceTag = this.currentVariant.price;
      regularPriceElement.innerHTML = Shopify.formatMoney(
        this.regularPriceTag,
        window.theme.moneyFormat
      );
      regularPriceElement.setAttribute('data-price', this.regularPriceTag);
    }

    if (compareAtPriceElement) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;
      if (this.compareAtPriceTag) {
        compareAtPriceElement.innerHTML = Shopify.formatMoney(
          this.compareAtPriceTag,
          window.theme.moneyFormat
        );
        compareAtPriceElement.setAttribute('data-price', this.compareAtPriceTag);
      } else {
        compareAtPriceElement.innerText = "";
        compareAtPriceElement.removeAttribute('data-price');
      }
    } else if (this.currentVariant.compare_at_price) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;
      const compareAtPriceEl = this.element.querySelector(".product-info__price--compare");

      if (compareAtPriceEl) {
        compareAtPriceEl.textContent = Shopify.formatMoney(
          this.compareAtPriceTag,
          window.theme.moneyFormat
        );
        compareAtPriceEl.setAttribute('data-price', this.compareAtPriceTag);
      }
    } else {
      if (compareAtPriceElement) {
        compareAtPriceElement.innerText = "";
        compareAtPriceElement.removeAttribute('data-price');
      }
    }
  }

  updateLowestPrice() {
    let allMetaVariants = document.querySelectorAll(".lowest-price-meta");
    const lowestPriceInput = document.querySelectorAll(
      ".product-info__price--lowest span"
    );

    const lowestPriceDiv = document.querySelectorAll(
      ".product-info__price--lowest"
    );

    allMetaVariants.forEach((meta) => {
      if (meta.getAttribute("data-variant_id") == this.currentVariant.id) {
        let lowestPrice = meta.getAttribute("meta-data");

        lowestPriceInput.forEach((input) => {
          input.innerHTML = Shopify.formatMoney(
            lowestPrice * 100,
            window.theme.moneyFormat
          );
        });

        lowestPriceDiv.forEach((item) => {
          item.style.display = "flex";
        });

        if (lowestPrice == 0) {
          lowestPriceDiv.forEach((item) => {
            item.style.display = "none";
          });
        }
      }
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".ProductInfo--Prices";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);


        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        this.toggleAddButton();
      });
  }

  toggleAddButton() {
    let hideButtons = document.querySelectorAll(".hideBtn");
    hideButtons.forEach(function (button) {
      button.classList.remove("hideBtn");
    });

    const addButton = document.querySelectorAll(".product__atc-button");

    if (!addButton) return;

    if (this.currentVariant.available == false) {
      addButton.forEach((button) => {
        button.classList.add("hideBtn");
      });
    } else {
      addButton.forEach((button) => {
        button.dataset.action = 'add-to-cart';
        if (button.classList.contains('product-module__product-atc--sticky')) {
          button.dataset.action = 'click-atc';
        }

        button.classList.remove("hideBtn");
        const addToCartTxt = button.querySelectorAll('.product__atc-button .ButtonText:not(.button-total-price)');
        addToCartTxt.forEach(txt => {
          txt.textContent = window.variantStrings.addToCart.toUpperCase();
        })
      });
    }

    this.showNotifyMeButton(this.currentVariant.available);
  }

  showNotifyMeButton(available) {
    if (!this.notifyButtons) return;

    if (available) {
      this.notifyButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "flex"));

    } else {
      this.notifyButtons.forEach((btn) => (btn.style.display = "flex"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class AccessoryProductQuantity extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.input = this.element.querySelector(".quantity-input");
    this.decreaseBtn = this.element.querySelector(".quantity-btn.decrease");
    this.increaseBtn = this.element.querySelector(".quantity-btn.increase");
    this.priceElement = this.element.querySelector(".pdp-accessory-product-card--price");

    this.initPriceSync();
    this.initAccessoryStateSync();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '.quantity-btn.increase', this.onIncreaseClick.bind(this));
    this.delegateElement.on('click', '.quantity-btn.decrease', this.onDecreaseClick.bind(this));
    this.delegateElement.on('change', '.pdp-accessory-product-card__checkbox', this.updateAccessoryState.bind(this));
    this.delegateElement.on('input', '.quantity-input', this.updateAccessoryState.bind(this));
  }

  initPriceSync() {
    if (!this.input || !this.priceElement || !this.increaseBtn || !this.decreaseBtn) return;

    const base = parseFloat(this.priceElement.dataset.basePrice);
    if (isNaN(base)) return;
    this.basePrice = base;

    this.updatePrice();
  }

  initAccessoryStateSync() {
    const checkbox = this.closest('.pdp-accessory-product-card')?.querySelector('.pdp-accessory-product-card__checkbox');
    const rightElement = this.element.querySelector('.pdp-accessory-product-card--right');
    const quantityInput = this.closest('.pdp-accessory-product-card')?.querySelector('.quantity-input');
    const decreaseButton = this.closest('.pdp-accessory-product-card')?.querySelector('.quantity-btn.decrease');

    if (checkbox && rightElement && quantityInput && decreaseButton) {
      const updateState = () => {
        rightElement.classList.toggle('pdp_accessory-disabled', !checkbox.checked);

        (checkbox.checked && parseInt(quantityInput.value, 10) === 1)
          ? decreaseButton.classList.add('decrease--disabled')
          : decreaseButton.classList.remove('decrease--disabled');
      };

      this.updateAccessoryState = updateState;
      updateState();
    }
  }

  onIncreaseClick(event) {
    let value = Number(this.input.value);
    const max = parseInt(this.input.max);

    if (value < max) {
      this.input.value = value + 1;
      this.updatePrice();
      this.triggerQuantityInputEvent();
    }
  }

  onDecreaseClick(event) {
    let value = Number(this.input.value);
    const min = parseInt(this.input.min);

    if (value > min) {
      this.input.value = value - 1;
      this.updatePrice();
      this.triggerQuantityInputEvent();
    }
  }

  updatePrice() {
    const min = parseInt(this.input.min);
    const max = parseInt(this.input.max);
    let quantity = Math.min(Math.max(parseInt(this.input.value) || 0, min), max);
    this.input.value = quantity;

    const total = this.basePrice * quantity;
    this.priceElement.textContent = `+ ${Shopify.formatMoney(total, window.theme.moneyFormat)}`;

    this.dispatchEvent(new CustomEvent("quantity:changed", { bubbles: true }));
  }

  triggerQuantityInputEvent() {
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('accessory-product-quantity', AccessoryProductQuantity);

class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.pageOverlayElement = document.querySelector(".pageOverlayPDP");
    this.allNotifications = this.element.querySelectorAll(
      ".product-module__notify-action"
    );
    this.emailContainer = this.element.querySelector(
      "#product-module__notify-me-input"
    );
    this.subtitle = this.element.querySelector(".product-module__notify-text");
    this.productId = document.querySelector(
      'form[data-product-form] [name="id"]'
    ).dataset.productid;

    this.variantId = document.querySelector(
      '[name="notify_variant"]'
    ).dataset.id;

    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideListener = this.closeNotifyMe.bind(this);

    this.delegateBody.on(
      "click",
      '[data-action="notify-open"]',
      this.openNotifyMe.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="subscribe"]',
      this.handleSubscribe.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="notify-close-success"]',
      this.closeNotifyMeSuccess.bind(this)
    );
    this.delegateBody.on("notify:change", this.updateVariantId.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="notify-close"]',
      this.closeNotifyMe.bind(this)
    );
  }

  updateVariantId(e) {
    this.variantId = e.detail.id;
  }

  handleSubscribe() {
    const email = this.element.querySelector('[name="notify_email"]').value;
    let promise = SI.create(email, this.variantId, this.productId);

    if (email !== "" && email.includes("@")) {
      promise.then((st, data) => {
        let resp = SI.parseJSON(data);
        if (resp.status == "OK") {
          this.showNotification("success");
        } else {
          this.showNotification("error");
        }
      });
    } else {
      this.showNotification("email-error");
    }
  }

  clearNotifications() {
    this.allNotifications.forEach((el) =>
      el.setAttribute("aria-hidden", true)
    );
  }

  showNotification(string) {
    this.clearNotifications();

    let activeNotification;
    switch (string) {
      case "success":
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--success"
        );
        let activeBtn = this.element.querySelector(
          ".product-module__notify-button--success"
        );
        let subsBtn = this.element.querySelector(
          ".product-module__notify-button--subscribe"
        );
        subsBtn.style.display = "none";
        activeBtn.setAttribute("aria-hidden", false);
        activeNotification.setAttribute("aria-hidden", false);
        this.emailContainer.value = '';
        this.emailContainer.style.display = "none";
        this.subtitle.style.display = "none";
        break;

      case "email-error":
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--email-error"
        );
        break;

      default:
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--error"
        );
        break;
    }

    activeNotification.setAttribute("aria-hidden", false);
  }

  openNotifyMe(e) {
    e.preventDefault();
    this.element.setAttribute("aria-hidden", false);
    trapFocus(this.element);

    this.pageOverlayElement.classList.add("is-visible");

    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
  }

  closeNotifyMe(e) {
    this.element.setAttribute("aria-hidden", true);

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    // Remove scrolllock and clear notifications after the popup disappears so there are no visible layout shifts
    this.element.addEventListener(
      "transitionend",
      () => {
        if (e.target.closest('[data-action="notify-close"]')) {
          setTimeout(() => {
            bodyScrollLock.enableBodyScroll(
              this.element,
              bodyScrollLockOptions
            );
            this.clearNotifications();
          }, 50);
        } else {
          bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
          this.clearNotifications();
        }
      },
      { once: true }
    );
  }

  closeNotifyMeSuccess(e) {
    this.element.setAttribute("aria-hidden", true);

    this.pageOverlayElement.classList.remove("is-visible");

    let activeBtn = this.element.querySelector(
      ".product-module__notify-button--success"
    );
    let subsBtn = this.element.querySelector(
      ".product-module__notify-button--subscribe"
    );

    let activeNotification = this.element.querySelector(
      ".product-module__notify-action--success"
    );

    activeNotification.setAttribute("aria-hidden", true);
    subsBtn.style.display = "block";
    activeBtn.setAttribute("aria-hidden", true);
    this.emailContainer.style.display = "flex";
    this.emailContainer.value = '';
    this.subtitle.style.display = "block";

    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );

    this.element.addEventListener(
      "transitionend",
      () => {
        if (e.target.closest('[data-action="notify-close"]')) {
          setTimeout(() => {
            bodyScrollLock.enableBodyScroll(
              this.element,
              bodyScrollLockOptions
            );
          }, 50);
        } else {
          bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
        }
      },
      { once: true }
    );
  }
}

customElements.define("notify-me-popup", NotifyMe);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    
     this.breakpoint = responsive.getCurrentBreakpoint();
     if(this.breakpoint === "desktop")
          this.pageOverlayElement = document.querySelector(".pageOverlay");
        else
          this.pageOverlayElement = document.querySelector(".localizationOverlay");

    this.outerWrapper = this.element.querySelector(".search__outer-wrapper");
    this.searchResultsElement = this.element.querySelector(".search__wrapper");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector('.search__input-clear');
    this.headerTransparent = false;
    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );


    this.bindEvents();
  }


  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateBody.on(
        "keydown",
        this.onEsc.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
    this.handle = document.querySelector('.search__swipe-element');
     this.initDragHandle();
     this.initCarousel();
  }

  initDragHandle() {
    let startY = 0, currentY = 0;
    const threshold = 80, wrap = document.querySelector('.search__outer-wrapper');

    this.handle.addEventListener('touchstart', e => {
      startY = e.touches[0].clientY;
      wrap.style.transition = 'none';
    });

    this.handle.addEventListener('touchmove', e => {
      if (!startY) return;
      currentY = e.touches[0].clientY;
      const dy = currentY - startY;
      if (dy > 0) wrap.style.transform = `translateY(${dy}px)`;
    });

    this.handle.addEventListener('touchend', e => {
      wrap.style.transform = '';

      if (currentY - startY > threshold) {
        this.pageOverlayElement.classList.remove("is-visible");
        this.element.setAttribute("aria-hidden", "true");
        this.element.style.display= "";
        wrap.style.transform = '';
      } else {
        wrap.style.transform = '';
      }

      startY = currentY = 0;
    });
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.closeSearch(e);
    }
  }

  initCarousel() {
      var carousel = this.searchResultsElement.querySelector(
        "[data-swiper-settings]"
      );
      if (carousel) {
         new RevolutionSwiper(carousel);
      }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();

    this.pageOverlayElement.classList.add("is-visible");
    this.element.style.display = "block";
    this.element.setAttribute("aria-hidden", "true"); // Start hidden (off-screen)

    // Force a reflow so the browser registers the initial state
    void this.element.offsetWidth;

    // Now trigger the transition to visible
    this.element.setAttribute("aria-hidden", "false");

    // ...rest of your code (body scroll lock, focus, etc.)
    const elToLock = document.querySelector("body");
    elToLock.style.overflow = "hidden";
    bodyScrollLock.disableBodyScroll(
        this.element.querySelector('[data-scrollable]'),
        bodyScrollLockOptions
    );
    setTimeout(() => {
      if (this.searchInputElement) {
        this.searchInputElement.focus();
      }
    }, 200);

    if (document.querySelector('.Header--Transparent')) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
      this.headerTransparent = true;
    }

    this.element.dispatchEvent(
          new CustomEvent("menu:close", { bubbles: true })
        );

    this.isOpen = true;
new AddToCart(this.element);
    if (this.pageOverlayElement || this.outerWrapper) {
      this.closeListener = this.closeSearch.bind(this);
      this.outerWrapper.addEventListener("click", this.closeListener);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  closeSearch(ev) {
    if (!this.isOpen || (!ev.target.classList.contains("search__outer-wrapper") && ev.key !== "Escape" && !ev.target.classList.contains("pageOverlay") && !ev.target.classList.contains("closeSearch") && !ev.target.classList.contains("localizationOverlay") && !ev.target.classList.contains("search__swipe-line"))) {
      return;
    }

    this.resetSearch();
    const elToLock = document.querySelector("body");
    elToLock.style = "";

    // Attach transitionend handler BEFORE changing aria-hidden
    let called = false;
    const cleanup = () => {
      if (called) return;
      called = true;
      this.element.style.display = "none";
      if (this.headerTransparent) {
        document.body
          .querySelector("#header")
          .classList.add("Header--Transparent");
      }
      this.element.removeEventListener('transitionend', onTransitionEnd);
    };

    const onTransitionEnd = (e) => {
      if (e.target === this.element && e.propertyName === "transform") {
        cleanup();
      }
    };
    this.element.addEventListener('transitionend', onTransitionEnd);

    // Fallback in case transitionend doesn't fire
    setTimeout(cleanup, 400);

    this.element.setAttribute('aria-hidden', "true");

    bodyScrollLock.enableBodyScroll(this.element.querySelector('[data-scrollable]'), bodyScrollLockOptions);

    this.pageOverlayElement.classList.remove("is-visible");
    this.isOpen = false;
  }


  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".search__wrapper");
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute('aria-hidden', 'false');
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.lastInputValue)}&resources[limit_scope]=each&section_id=search-predictive`);

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-predictive').innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement('div');
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector('template');
      const currentSuggestedQueries = this.element.querySelector('.predictiveSearch--queries');
      const currentRecentQueris = this.element.querySelector('#predictiveSearch--recentSearches');


      this.searchResultsElement.innerHTML = resultsMarkup;
      this.initCarousel();

      if (suggestedQueries) {
        if (currentRecentQueris) {
          currentRecentQueris.remove();
        }

        if (currentSuggestedQueries) {
          currentSuggestedQueries.remove();
        }
        const node = suggestedQueries
          .content.firstElementChild.cloneNode(true);
        this.searchResultsElement.prepend(node);
      }


      this.searchResultsElement.style.opacity = 1;

      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }

  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector('.predictiveSearch--queries');
    if (currentSuggestedQueries) currentSuggestedQueries.remove();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");
    this.searchInputElement.focus()

    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute('aria-hidden', 'true');
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

}
customElements.define("search-bar", SearchBar);




class SearchComponent extends HTMLElement {
  constructor() {
    super();
    this.delegate = new Delegate(this);                                             // event delegation
    this.productBtn     = this.querySelector('#productBtn');                         // product tab button
    this.articleBtn     = this.querySelector('#articleBtn');                         // article tab button
    this.productGrid    = this.querySelector('.main-search-grid--products');         // products grid
    this.articleGrid    = this.querySelector('.main-search-grid--articles');         // articles grid
    this.productCountEl = this.querySelector('#global-product-count');               // product count element
    this.articleCountEl = this.querySelector('#global-article-count');               // article count element
    this.filterBar      = this.querySelector('.filter-bar');                         // filter bar element
    this.observer       = new MutationObserver(() => this.updateCounts());            // watch grid changes
  }

  connectedCallback() {
    this.delegate.on('click', 'a[data-action="toggle-products"]', e => { e.preventDefault(); this.showProducts(); });  // wire product toggle
    this.delegate.on('click', 'a[data-action="toggle-articles"]', e => { e.preventDefault(); this.showArticles(); }); // wire article toggle
    if (this.productGrid)  this.observer.observe(this.productGrid,  { childList: true, subtree: true });             // observe product grid
    if (this.articleGrid)  this.observer.observe(this.articleGrid,  { childList: true, subtree: true });             // observe article grid
    this.updateCounts();                                                                                            // initial count update
    const params = new URLSearchParams(window.location.search);                                                     // read URL params
    if (this.productBtn?.style.display === 'none') { this.showArticles(); }                                          // if only articles available
    else if (this.articleBtn?.style.display === 'none') { this.showProducts(); }                                     // if only products available
    else { params.get('type') === 'article' ? this.showArticles() : this.showProducts(); }                          // default by URL
  }

  updateCounts() {
    const prodCount = this.productGrid    ? this.productGrid.querySelectorAll('.is-product').length : 0; // count products
    const artCount  = this.articleGrid    ? this.articleGrid.querySelectorAll('.blog-article').length : 0; // count articles
    if (this.productCountEl) this.productCountEl.textContent = prodCount;                                   // update product count
    if (this.articleCountEl) this.articleCountEl.textContent = artCount;                                   // update article count
    if (this.productBtn)     this.productBtn.style.display     = prodCount > 0 ? '' : 'none';               // hide product tab if empty
    if (this.articleBtn)     this.articleBtn.style.display     = artCount  > 0 ? '' : 'none';               // hide article tab if empty
  }

  showProducts() {
    this.productBtn?.classList.add('active');    // activate product tab
    this.articleBtn?.classList.remove('active'); // deactivate article tab
    if (this.productGrid) this.productGrid.style.display = 'grid';    // show products
    if (this.articleGrid) this.articleGrid.style.display = 'none';    // hide articles
    if (this.filterBar)    this.filterBar.style.display    = '';      // show filter bar
    this.updateURL('product');                                         // sync URL
  }

  showArticles() {
    this.productBtn?.classList.remove('active'); // deactivate product tab
    this.articleBtn?.classList.add('active');    // activate article tab
    if (this.productGrid) this.productGrid.style.display = 'none';    // hide products
    if (this.articleGrid) this.articleGrid.style.display = 'grid';    // show articles
    if (this.filterBar)    this.filterBar.style.display    = 'none';  // hide filter bar
    this.updateURL('article');                                        // sync URL
  }

  updateURL(type) {
    const params = new URLSearchParams(window.location.search); // get params
    params.set('type', type);                                  // set new type
    window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`); // replace URL
  }
}

customElements.define('search-component', SearchComponent); 



class MainCollection extends HTMLElement {
  constructor() {
    super();
    this.element = this;

  }

  connectedCallback() {
    new AddToCart(this.element);

}
}

customElements.define("main-collection", MainCollection);
class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.stickyLinksTopPadding = this.stickyLinksTopPadding.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if(!isMobile) document.addEventListener("scroll", this.stickyLinksTopPadding);
  }

  stickyLinksTopPadding() {
    const linkList = this.element.querySelector(".tc-layout-wrapper__linklist");
    if (linkList) {
      const isSticky = linkList.getBoundingClientRect().top === 0;

      if (isSticky) {
        linkList.style.paddingTop = "1.5rem";
      } else {
        linkList.style.paddingTop = "0rem";
      }
    }
  }
}

customElements.define("terms-and-conditions", TermsAndConditions);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    const form = this.element.querySelector('form');
    if (form) {
      form.addEventListener('submit', e => {
        e.preventDefault();
        console.log('perform form check');
      });
    }

    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.delegateElement.on(
      "click",
      ".Contact-Btn",
      (e) => {
        const errors = this.validationCheck();

        if (Object.keys(errors).length > 0) {
          e.preventDefault();
          this.showValidationErrors(errors);
        }
      }
    );

    this.delegateElement.on(
      "input",
      "input",
      (e) => {
        const input = e.target;
        input.classList.remove("contact-form__input-error");
  
        const next = input.nextElementSibling;
        if (next && next.classList.contains("content_form--error")) {
          next.remove();
        }
      }
    );
  }

  validationCheck() {
    const form = this.element.querySelector("form");
    if (!form) return {};
  
    const inputs = form.querySelectorAll("input");
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
     const phonePattern = /^[+0-9]+$/;
    const errors = {};
  
    inputs.forEach((input) => {
      const type = input.type;
      const value = input.value.trim();
      const key = input.name || input.id || `field-${[...inputs].indexOf(input)}`;
  
      if (type === "text" && input.hasAttribute("required") && !value) {
        errors[key] = input;
      }
  
      if (type === "email") {
        if (!value || !emailPattern.test(value)) {
          errors[key] = input;
        }
      }

     if (type === "tel") {
      // fail if empty or if anything other than +/digits is present
      if (!value || !phonePattern.test(value)) {
        errors[key] = input;
      }
    }
    });
  
    return errors;
  }

  showValidationErrors(errors) {
    this.element
      .querySelectorAll('.content_form--error')
      .forEach(el => el.remove());
  
    this.element
      .querySelectorAll('input.contact-form__input-error')
      .forEach(input => input.classList.remove('contact-form__input-error'));
  
    Object.values(errors).forEach(input => {
      input.classList.add('contact-form__input-error');
  
      const errP = document.createElement('p');
      errP.className = 'u-p4 AlertError formError content_form--error';

      const msg = input.getAttribute('error-message') || 'Invalid value';
      errP.textContent = msg;
  
      input.parentNode.insertBefore(errP, input.nextSibling);
    });
  }

  toggleButton() {
    this.buttonState = true;
  
    const allFields = this.element.querySelectorAll("[data-state='required']");
    allFields.forEach((item) => {
      const type = item.type;
  
      if (type === "checkbox" && !item.checked) {
        this.buttonState = false;
      }
    });
  
    const btn = this.element.querySelector(".Contact-Btn");
    if (btn) {
      if (this.buttonState) {
        btn.removeAttribute("disabled");
      } else {
        btn.setAttribute("disabled", true);
      }
    }
  }
}

customElements.define("contact-section", ContactSection);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
    this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

    if (window.location.href.indexOf("customer_posted=true#popupForm") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
      sessionStorage.setItem('newsletter-success', 'true');
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-signup"]',
      this.clickOpen.bind(this)
    );
  }

  clickOpen() {
    this.options.delay = 0;
    this.openNewsletter();
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;
    if (this.options.not_show_subscribed && this.options.is_subscribed) return;
    if (this.options.scroll_amount > 0) {
      document.addEventListener("scroll", this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    if (sessionStorage.getItem('newsletter-success') === 'true' && !this.options.edit_mode) return;
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }

    setTimeout(() => {
      this.element.style.display = "flex";

      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", "false");
      });

      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateBody.on(
        "keydown",
        this.onEsc.bind(this)
      );

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.closeNewsletter(e);
    }
  }

  onTransitionEnd = (event) => {
    if (event.propertyName === "opacity") {
      if (this.element.getAttribute("aria-hidden") === "true") {
        requestAnimationFrame(() => {
          this.element.style.display = "none"; // Only hide after the transition
          document.body.classList.remove("scrollLock");
          bodyScrollLock.enableBodyScroll(this.element);

          this.element.removeEventListener("transitionend", this.onTransitionEnd);
        });
      }
    }
  };

  closeNewsletter = () => {
    this.element.addEventListener("transitionend", this.onTransitionEnd);
    this.element.setAttribute("aria-hidden", "true");
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    this.element.offsetHeight;

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
  };

}

customElements.define("newsletter-popup", NewsletterPopup);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
    this.bindEvents();

  }
  bindEvents() {

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));

    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));

  }

    accountInputSubmit(e) {
    if (e.key === "Enter") this.submitLogin(e);
  }

  accountInputSubmitReg(e) {
    if (e.key === "Enter") this.submitRegistration(e);
  }

  accountInputSubmitForgot(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.accountRecover(e);
    }
  }

  toggleRecovery(event) {
  event.preventDefault();

  const id = event.target.dataset.id;

    const titleParent = event.target.closest('[data-title]');
    const newTitle = titleParent ? titleParent.dataset.title : '';
    this.setDrawerTitle(newTitle);


  // Toggle visibility between login and recovery forms
  if (id === 'recover') {
    this.element.querySelector('#recover').setAttribute('aria-visible', 'true');
    this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'false');
  } else {
    this.element.querySelector('#recover').setAttribute('aria-visible', 'false');
    this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'true');
  }
}





  async accountRecover(event) {
    event.preventDefault();
    const recoverEndpoint = "/account/recover";
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const buttonText = event.target.querySelector(".ButtonText");
    const loader = event.target.querySelector(".itemLoader");

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(recoverEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;

      console.log('temp', tempDiv);
      const recoverError = this.element.querySelector("#recover .accountDrawer--ErrorSpace");
      const recoverSuccess = this.element.querySelector("#recover .accountDrawer--SuccessSpace");
      if (responseText.includes("account__recover-email-error")) {
        recoverSuccess.classList.remove("is-visible");
        recoverError.innerHTML = "";
        recoverError.innerHTML = tempDiv.querySelector("#account__recover-email-error").innerHTML;
        recoverError.classList.add("is-visible");
      } else if (responseText.includes("account__form-success-msg")) {
        recoverError.classList.remove("is-visible");

        recoverSuccess.innerHTML = "";
        recoverSuccess.innerHTML = tempDiv.querySelector("#account__form-success-msg").innerHTML;
        recoverSuccess.classList.add("is-visible");


      }

      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the recovery request:", error);
    }
  }




  async submitRegistration(event) {
    event.preventDefault();
    const registrationEndpoint = `${window.routes.localeRootUrl}/account`;
    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#RegisterForm-FirstName").value,
        last_name: this.element.querySelector("#RegisterForm-LastName").value,
        email: this.element.querySelector("#RegisterForm-email").value,
        password: this.element.querySelector("#RegisterForm-password").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loader = event.target.closest("form").querySelector(".itemLoader");

    loader.classList.add("is-visible");

    try {
      const response = await fetch(registrationEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const registerEmailError = this.element.querySelector("#RegisterForm-email-error");
      const registerPasswordError = this.element.querySelector("#RegisterForm-password-error");
      const generalError = this.element.querySelector('#register .drawer__errors');

   


      if (responseText.indexOf("registerErrors") !== -1) {
        console.error("Error occurred during registration.");
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        const emailErrorElement = tempDiv.querySelector("#RegisterForm-email-error");
        const emailInput = this.element.querySelector("#RegisterForm-email");
        const emailField = emailInput.closest(".field");

        if (emailErrorElement) {

          registerEmailError.setAttribute("aria-hidden", "false");
          registerEmailError.innerHTML = "";

          registerEmailError.innerHTML = emailErrorElement.innerHTML;
          this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "true");

           emailField.classList.add("input--error");
        } else {
          this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
          registerEmailError.setAttribute("aria-hidden", "true");

          emailField.classList.remove("input--error");
        }

        const passwordErrorElement = tempDiv.querySelector("#RegisterForm-password-error");
        const passwordInput = this.element.querySelector("#RegisterForm-password");
        const passwordField = passwordInput.closest(".field");
        if (passwordErrorElement) {
          registerPasswordError.setAttribute("aria-hidden", "false");
          registerPasswordError.style.display = "block";
          registerPasswordError.innerHTML = "";
          registerPasswordError.innerHTML = tempDiv.querySelector("#RegisterForm-password-error").innerHTML;
          this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "true");

          passwordField.classList.add("input--error");
        } else {
          registerPasswordError.setAttribute("aria-hidden", "true");
          this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
           passwordField.classList.remove("input--error");
        }

        const generalErrorNew = tempDiv.querySelector("#account__register-email-error");
        if (generalErrorNew) {

          generalError.setAttribute("aria-hidden", "false");
          generalError.style.display = "block";
          generalError.innerHTML = "";
          generalError.innerHTML = generalErrorNew.innerHTML;
        }

      } else {
        registerPasswordError.setAttribute("aria-hidden", "true");
        this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
        this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
        registerEmailError.setAttribute("aria-hidden", "true");
        location.href = window.routes.account_url;
      }

      loader.classList.remove("is-visible");

    } catch (error) {
      console.error("An error occurred during the registration request:", error);
    }
  }





  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = `${window.routes.localeRootUrl}/account/login`;
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const buttonText = event.target.querySelector(".ButtonText");
    const loader = event.target.querySelector(".itemLoader");

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(loginEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
      
          const loginError = this.element.querySelector("#login .accountDrawer--ErrorSpace");
          loginError.innerHTML = "";
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = responseText;
          loginError.innerHTML =
            tempDiv.querySelector(".AlertError").innerHTML;
          loginError.classList.add("is-visible");

          // find the closest wrapper with class "field"
          const fieldErr = loginError.closest('.field');
          if (fieldErr) {
            fieldErr.classList.add('input--error');
          }
      } else {
        location.href = window.routes.account_url;
      }

      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the login request:", error);
    }
  }
// 🆕 Reusable drawer title setter
  setDrawerTitle(title) {
    const titleElement = this.element.querySelector('.acc-drawer__title');
    if (titleElement && title) {
      titleElement.textContent = title;
    }
  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const titleToSet = event.target.dataset.title;

    this.setDrawerTitle(titleToSet);

    const allTabs = this.element.querySelectorAll('.acc-drawer__tab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.accountContent');
  
  

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    event.target.setAttribute('aria-expanded', 'true');

    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
     
      }
  }

}

customElements.define("account-handler", AccountHandler);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    new Popup(this.element, true);
  }
}
customElements.define("localization-selectors", LocalizationSelectors);




class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    const self = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.slides = this.element.querySelectorAll(".announcement-animation");

    this.animeWrapper = this.element.querySelector('.announcement-bar__anim-wrapper');

    console.log(this.animeWrapper.getBoundingClientRect())

    document.documentElement.style.setProperty(
        "--animate-wrapper-width",
        this.animeWrapper.getBoundingClientRect().width + "px"
    );


    this.announcementBar = document.querySelector(".announcement-bar");
    document.documentElement.style.setProperty(
      "--announcement-height-fixed",
      this.element.clientHeight + "px"
    );

    this.fadeToggle = false;
    this.firstAnimation = true;
    window.onload = () => setTimeout(() => this.updateVisibleHeight(), 500);
    this.handleSmallAnimation();

    this.updateVisibleHeight();

    this.bindEvents();
  }

  connectedCallback() {
    document.documentElement.style.setProperty(
        "--announcement-height-fixed",
        this.element.clientHeight + "px"
    );
    this.updateVisibleHeight();
  }


  bindEvents() {
    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }

  updateVisibleHeight() {
    const rect = this.announcementBar.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    visibleHeight = Math.max(visibleHeight, 0);

    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );

    document.documentElement.style.setProperty(
        "--animate-wrapper-width",
        this.animeWrapper.getBoundingClientRect().width + "px"
    );
  }

  fadeSmall() {
    const mySlides = this.slides;
    const numSlides = mySlides.length;
    let currentSlideIndex = 0;

    const animate = () => {
      if (currentSlideIndex > 0) {
        mySlides[currentSlideIndex - 1].classList.remove("fade-in");
      }

      mySlides[currentSlideIndex].classList.add("fade-in");

      this.slidesTimeout = setTimeout(() => {
        mySlides[currentSlideIndex].classList.remove("fade-in");
        currentSlideIndex = (currentSlideIndex + 1) % numSlides;
        animate();
      }, this.options.interval);
    };

    animate();
  }

  handleSmallAnimation() {
    // if (!this.firstAnimation && this.animateBig) this.stopFadeBig();

    this.slides.forEach((slide, index) => {
      if (index !== 0) slide.style.display = "none";
    });

    setTimeout(() => {
      this.fadeSmall();

      this.slides.forEach((slide, index) => {
        if (index !== 0) slide.style.display = "flex";
      });

      if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
    }, 150);
  }



}
customElements.define("announcement-bar", AnimatedAnnouncementBar);

class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiper = this.element.querySelector(".swiper");

    if(
        this.swiper &&
        this.swiper.hasAttribute("data-swiper-settings") &&
        !responsive.matchesBreakpoint("lap_and_up"))
    {
      new RevolutionSwiper(this.swiper)
    }
  }
}


customElements.define("usp-section", UspSection);

document.addEventListener('click', function(e) {
  // Tidio Trigger
  if (e.target.closest('[data-tidio-trigger]')) {
    if (window.tidioChatApi) window.tidioChatApi.open();
  }
});

class KlaviyoPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.initKlaviyoTrigger();
  }

  initKlaviyoTrigger() {
    const button = this.querySelector('.klaviyo_form_trigger');
    const formId = this.dataset.formId; // get the ID passed from Liquid

    if (button && formId) {
      button.addEventListener('click', () => {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      });
    }
  }
}

customElements.define('klaviyo-popup', KlaviyoPopup);


class AddonPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
   const popups = this.element.querySelectorAll('.pdp_addon-popup');

    popups.forEach(popup => {
      const closeBtn = popup.querySelector('.product-popup__close-button');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          window.globalPopup.closePopup(popup);
        });
      }

      document.body.insertBefore(popup, document.querySelector('.pageOverlay')?.nextSibling);
    });

    const svgIcon = this.querySelector('svg.Svg--check');

    if (svgIcon) {
      const clonedSVG = svgIcon.cloneNode(true);

      this.element.querySelectorAll('ul > li').forEach(li => {
        if (!li.classList.contains('has-checkmark')) {
          const iconClone = clonedSVG.cloneNode(true);
          iconClone.classList.add('checkmark-icon');
          li.prepend(iconClone);
          li.classList.add('has-checkmark');
          li.classList.add('u-p4');
        }
      });
    }
  }
}

customElements.define("addon-popup", AddonPopup);

class AccessoryPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    const popups = this.element.querySelectorAll('.pdp_accessory-popup');

    popups.forEach(popup => {
      const closeBtn = popup.querySelector('.product-popup__close-button');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          window.globalPopup.closePopup(popup);
        });
      }

      document.body.insertBefore(popup, document.querySelector('.pageOverlay')?.nextSibling);
    });
  }
}

customElements.define("accessory-popup", AccessoryPopup);

class ProductPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.dragStartY = null;
    this.handle = null;
    this.originalTransition = null;
  }

  connectedCallback() {
    const swiperElement = this.element.querySelector('.swiper');
    const slides = swiperElement?.querySelectorAll('.swiper-slide') || [];

    if (swiperElement && slides.length > 1) {
      this.carousel = new RevolutionSwiper(swiperElement);
    } else {
      const pagination = this.element.querySelector('.product-popup__swiper-pagination');
      if (pagination) {
        pagination.style.display = 'none';
      }

      const prevButton = this.element.querySelector('.swiperPrevId--' + this.element.dataset.productId);
      const nextButton = this.element.querySelector('.swiperNextId--' + this.element.dataset.productId);

      if (prevButton) prevButton.style.display = 'none';
      if (nextButton) nextButton.style.display = 'none';
    }

    const closeBtn = this.element.querySelector('.product-popup__close-button');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        const popup = this.element.closest('.Popup');
        if (popup) {
          window.globalPopup.closePopup(popup);
        }
      });
    }

    this.handle = this.element.querySelector('[data-action="drag-handle"]');
    if (this.handle) {
      this.handle.addEventListener('touchstart', this.onTouchStart.bind(this));
      this.handle.addEventListener('touchmove', this.onTouchMove.bind(this));
      this.handle.addEventListener('touchend', this.onTouchEnd.bind(this));
    }
  }

  onTouchStart(e) {
    this.dragStartY = e.touches[0].clientY;

    const popupContainer = this.element.closest('.Popup');
    if (popupContainer) {
      this.originalTransition = popupContainer.style.transition || '';
      popupContainer.style.transition = 'none';
    }
  }

  onTouchMove(e) {
    const deltaY = e.touches[0].clientY - this.dragStartY;
    if (deltaY > 0) {
      const popupContainer = this.element.closest('.Popup');
      if (popupContainer) {
        popupContainer.style.transform = `translateY(${deltaY}px)`;
      }
    }
  }

  onTouchEnd(e) {
    const deltaY = e.changedTouches[0].clientY - this.dragStartY;
    const popupContainer = this.element.closest('.Popup');

    if (popupContainer) {
      popupContainer.style.transition = this.originalTransition;

      if (deltaY > 100) {
        window.globalPopup.closePopup(popupContainer);
        popupContainer.removeAttribute('style');
      } else {
        popupContainer.style.transform = '';
      }
    }
  }
}

customElements.define("product-popup", ProductPopup);


class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    const hasText = [...this.querySelectorAll('.richtext-block')]
      .some(block => block.textContent.trim().length > 0);

    if (!hasText) {
      this.parentElement.style.display = 'none';
      return;
    }

    const svgIcon = this.querySelector('svg.Svg--check');
    if (svgIcon) {
      const clonedSVG = svgIcon.cloneNode(true);

      const ul = this.element.querySelector('ul');
      let parentWithUClass = null;

      if (ul) {
        const parent = ul.parentElement;
        const grandparent = parent?.parentElement;

        parentWithUClass = [...(parent?.classList || []), ...(grandparent?.classList || [])]
          .find(cls => cls.startsWith('u-'));
      }

      this.element.querySelectorAll('ul > li').forEach(li => {
        if (!li.classList.contains('has-checkmark')) {
          const iconClone = clonedSVG.cloneNode(true);
          iconClone.classList.add('checkmark-icon');
          li.prepend(iconClone);
          li.classList.add('has-checkmark');

          if (parentWithUClass) {
            li.classList.add(parentWithUClass);
          }
        }
      });
    }
  }
}

customElements.define("product-description", ProductDescription);


class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
  }

  connectedCallback() {
    this.searchInput = this.element.querySelector(".faq--search");
    this.searchBar = this.element.querySelector('.faq__search-bar--wrapper');
    this.termsBlocks = document.querySelectorAll(".faq__block--heading");
    this.noResultsElement = document.querySelector("#faq__results--none");
    this.firstTag = this.element.querySelector('.faq__tab--link');
    if (this.firstTag) {
      this.firstTag.classList.add("is-active");
    }
    this.bindEvents();
    this.validateTabs();
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);
    this.delegateElement.on("click", '[data-action="handle-tab-click"]', this.handleTabClick.bind(this));
    this.delegateElement.on("click", '[data-action="clear-search"]', this.clearSearch.bind(this));

    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.onInputListener
    );

    this.handleScrollListener = this.handleScroll.bind(this);
    scrollListener.addScrollListener(this, this.handleScrollListener);
  }

  handleSearch() {
  const searchTerm = this.searchInput.value.toLowerCase().trim();
  const clearBtn = this.element.querySelector(".supportFaq--mobileClearBtn");

  if (clearBtn) clearBtn.style.display = this.searchInput.value ? "flex" : "none";

  if (searchTerm === "") {
    this.termsBlocks.forEach((block) => {
      block.classList.remove("is-hidden");
      const questions = block.querySelectorAll(".Dropdown.dropdown-border");
      questions.forEach((content) => content.classList.remove("is-hidden"));
    });
    this.noResultsElement.classList.add("is-hidden");
    return;
  }

  let hasMatch = false;

  this.termsBlocks.forEach((block) => {
    const questions = block.querySelectorAll(".Dropdown.dropdown-border");
    let blockMatch = false;

    const textBlocks = block.querySelectorAll('.text-block__text > *');
    let titleMatch = false;

    textBlocks.forEach(el => {
      if (el.textContent.toLowerCase().includes(searchTerm)) {
        titleMatch = true;
      }
    });

    if (titleMatch) {
      block.classList.remove("is-hidden");
      questions.forEach((content) => content.classList.remove("is-hidden"));
      blockMatch = true;
    } else {
      questions.forEach((questionWrapper) => {
        const questionText = questionWrapper.textContent.toLowerCase();
        if (questionText.includes(searchTerm)) {
          questionWrapper.classList.remove("is-hidden");
          blockMatch = true;
        } else {
          questionWrapper.classList.add("is-hidden");
        }
      });

      if (blockMatch) {
        block.classList.remove("is-hidden");
      } else {
        block.classList.add("is-hidden");
      }
    }

    if (blockMatch) hasMatch = true;
  });

  if (!hasMatch) {
    this.termsBlocks.forEach((block) => {
      block.classList.remove("is-hidden");
      block.querySelectorAll(".Dropdown.dropdown-border").forEach((content) =>
        content.classList.remove("is-hidden")
      );
    });

    this.noResultsElement.classList.remove("is-hidden");
  } else {
    this.noResultsElement.classList.add("is-hidden");
  }
}

  clearSearch() {
    const clearBtn = this.element.querySelector(".supportFaq--mobileClearBtn");
    const inputValue = this.element.querySelector(".faq--search.mobile");

    // Reset search input
    if (inputValue) inputValue.value = "";

    // Hide elements that should be hidden initially
    if (clearBtn) clearBtn.style.display = "none";

    // Reset FAQ term sections
    this.termsBlocks.forEach((block) => {
      block.classList.remove("is-hidden");
      const questions = block.querySelectorAll(".Dropdown.dropdown-border");
      questions.forEach((content) => content.classList.remove("is-hidden"));
    });
    this.noResultsElement.classList.add("is-hidden");
    inputValue.focus();
  }

  handleTabClick(event, target) {
    event.preventDefault();

    const targetId = target.getAttribute('href').substring(1);
    const newUrl = `${window.location.pathname}#${targetId}`;
    history.pushState(null, null, newUrl);

    const otherTabs = this.element.querySelectorAll(".faq__tab--link");
    if (!target.classList.contains("is-active")) {
      otherTabs.forEach(tab => {
        tab.classList.remove("is-active");
      });

      target.classList.add("is-active");
    }

    const targetElement = this.element.querySelector(`#${targetId}`);

    if (targetElement) {
      this.scrollToSection(targetElement);
    }
  }

  validateTabs() {
    const tabSlides = this.element.querySelectorAll('.faq__swiper--slide');

    tabSlides.forEach(slide => {
      const link = slide.querySelector('a[href^="#"]');
      if (!link) return;

      const targetId = link.getAttribute('href').substring(1);
      const targetElement = this.element.querySelector(`#${targetId}`);

      if (!targetElement) {
        slide.remove();
      }
    });
  }

  scrollToSection(targetElement) {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed')) || 0;
    let offset = headerHeight + 16;
    if (responsive.matchesBreakpoint('pocket') && this.searchBar) {
      offset = offset + this.searchBar.offsetHeight;
    }

    if (responsive.matchesBreakpoint('lap_and_up') ) {
      offset += 87;
    }

    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });

    this.slideToActiveTab(200);
  }

  slideToActiveTab(delay = 0) {
    clearTimeout(this.slideToActiveTabTimeout);

    this.slideToActiveTabTimeout = setTimeout(() => {
      const activeLink = this.element.querySelector('.faq__tab--link.is-active');
      if (!activeLink) return;

      const slideElement = activeLink.closest('.swiper-slide');
      if (!slideElement) return;

      const swiperEl = this.element.querySelector('.faq__swiper');
      if (!swiperEl || !swiperEl.swiper) return;

      const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
      const activeIndex = slides.indexOf(slideElement);

      if (activeIndex !== -1) {
        swiperEl.swiper.slideTo(activeIndex);
      }
    }, delay);
  }

  handleScroll() {
    if (this.element.dataset.clicked == "true") return;
    const faqSubheaders = this.element.querySelectorAll(".faq__block--heading");
    let threshold = 260;

    if (responsive.matchesBreakpoint("lap_and_up")) {
      threshold = 200;
    }

    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(
        0,
        faqSubheader.getBoundingClientRect().top
      );
      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        this.removeAllLinks();
        const faqSection = faqSubheader.closest(".faq__block--heading").id;
        const anchorElements = this.element.querySelectorAll(
          `a[href="#${faqSection}"]`
        );

        anchorElements.forEach((item) => {
          item.classList.add("is-active");

        });

        this.slideToActiveTab();
      }
    });
  }

  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".is-active");
    linkedItems.forEach((item) => {
      item.classList.remove("is-active");
    });
  }
}

customElements.define("faq-section", FAQSection);

class FAQCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".faq__swiper");

    if(!responsive.matchesBreakpoint("lap_and_up")) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
}
customElements.define("faq-carousel", FAQCarousel);

class FAQGroup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.setUpTabsContent();
    this.setUpHoverEffects();
    this.setUpSyncOnClick();
  }

  setUpTabsContent() {
    const firstTab = this.element.querySelector(".info__dropdown-button");

    this.element.querySelectorAll('.info__dropdown-button--number').forEach((el, i) => {
      el.textContent = (i + 1).toString().padStart(2, '0');
    });
  }

  setUpHoverEffects() {
    if (!responsive.matchesBreakpoint("lap_and_up")) return;

    const dropdowns = this.element.querySelectorAll('.Dropdown');

    dropdowns.forEach(dropdown => {
      dropdown.addEventListener('mouseenter', () => {
        const prev = dropdown.previousElementSibling;
        if (prev?.classList.contains('Dropdown')) {
          prev.classList.add('dropdown-border--transparent-hover');
        }
      });

      dropdown.addEventListener('mouseleave', () => {
        const prev = dropdown.previousElementSibling;
        if (prev?.classList.contains('Dropdown')) {
          prev.classList.remove('dropdown-border--transparent-hover');
        }
      });
    });
  }

  syncDropdownBorders() {
    const dropdowns = document.body.querySelectorAll('.Dropdown');

    dropdowns.forEach(dropdown => {
      const next = dropdown.nextElementSibling;
      if (next?.classList.contains('Dropdown')) {
        const isNextExpanded = next.getAttribute('aria-expanded') === 'true';

        if (isNextExpanded) {
          dropdown.classList.add('dropdown-border--transparent');
        } else {
          dropdown.classList.remove('dropdown-border--transparent');
        }
      } else {
        dropdown.classList.remove('dropdown-border--transparent');
      }
    });
  }

  syncDropdownExpandedStates() {
    const dropdowns = document.body.querySelectorAll('.Dropdown');

    dropdowns.forEach(dropdown => {
      const btn = dropdown.querySelector(".info__dropdown-button");
      if (btn) {
        const isExpanded = btn.getAttribute("aria-expanded") === "true";
        dropdown.setAttribute("aria-expanded", isExpanded);
      }
    });
  }

  setUpSyncOnClick() {
    this.element.querySelectorAll('.info__dropdown-button').forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          this.syncDropdownBorders();
        }, 0);
      });
    });
  }
}

customElements.define("faq-group", FAQGroup);


class TermsCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".tc__swiper");

    if (!responsive.matchesBreakpoint("lap_and_up")) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
  }
}
customElements.define("terms-carousel", TermsCarousel);



const lerp = (c, t, f) => c * (1 - f) + t * f;
class AnimatedCartUspsBar extends HTMLElement {
  constructor() {
    super();
    // Default settings and state
    this.speed       = 30;       // seconds
    this.fps         = 60;
    this.paused      = false;
    this.lerp        = { current: 0, target: 0 };
    this.factor      = 0.1;
    this.pxPerFrame  = 0;
    this.gutter      = 0;       // in px
    this.animationEnabled = true;

    // Internal flag so we only start animate() once
    this._hasStarted = false;

    // Will be set in connectedCallback()
    this.wrapper         = null;
    this.container       = null;
    this.resizeObserver  = null;
  }

  connectedCallback() {
    this.wrapper   = this.querySelector('.cart-drawer__usp-bar--duplicate-wrapper');
    this.container = this.querySelector('.cart-drawer__usp-bar--anim-wrapper');

    // Speed override from data-settings
    const speedAttr = parseFloat(this.getAttribute('data-settings'));
    if (!isNaN(speedAttr)) this.speed = speedAttr;

    // Parse JSON for enableAnimation flag
    const json = this.getAttribute('data-block-settings');
    if (json) {
      try {
        const parsed = JSON.parse(json);
        if (parsed.enableAnimation === false) {
          this.animationEnabled = false;
        }
      } catch (e) {
        console.warn('Invalid data-block-settings:', e);
      }
    }

    if (this.animationEnabled) {
      this.init();
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  init() {
    this.cloneItems();
    this.measure();         // does initial measurement + kicks off animation
    this.observeResize();
    this.bindInteractions();
  }

  cloneItems() {

    if(this.wrapper.children.length === 1){
      this.wrapper.style.gap = "25rem"
    }
    // Duplicate each child so we can scroll seamlessly
    Array.from(this.wrapper.children).forEach(child =>
      this.wrapper.appendChild(child.cloneNode(true))
    );
  }

  measure() {
    requestAnimationFrame(() => {
      const contentWidth = this.wrapper.scrollWidth;   // full, double-run width
      const hostRect     = this.getBoundingClientRect();
      const parentRect   = this.parentElement.getBoundingClientRect();
      this.gutter        = (hostRect.width - parentRect.width) / 2;

      // Expand wrapper to cover two runs + gutters
      this.wrapper.style.width   = `${contentWidth + this.gutter * 2}px`;
      // Mask width = host width
      this.container.style.width = `${hostRect.width}px`;

      // px moved per frame = oneRunWidth / (seconds * fps)
      const oneRun     = contentWidth / 2;
      this.pxPerFrame  = oneRun / (this.speed * this.fps);

      // Lock in height to prevent jumps
      this.style.height = `${this.container.offsetHeight}px`;

      // Reset lerp position & initial transform
      this.lerp.current = this.lerp.target = 0;
      this.wrapper.style.transform = `translateX(-${this.gutter}px)`;

      // Start animation loop once
      if (!this._hasStarted) {
        this._hasStarted = true;
        this.animate();
      }
    });
  }

  observeResize() {
    this.resizeObserver = new ResizeObserver(() => this.measure());
    this.resizeObserver.observe(this.wrapper);
  }

  bindInteractions() {
    this.container.addEventListener('mouseenter', () => this.paused = true);
    this.container.addEventListener('mouseleave', () => this.paused = false);
    this.container.addEventListener('click', () => {
      if (!window.matchMedia('(hover: hover)').matches) {
        this.paused = !this.paused;
      }
    });
  }

  animate() {
    const step = () => {
      if (!this.paused) {
        // Only proceed if we have at least one item
        if (this.wrapper && this.wrapper.children.length > 0) {
          const first = this.wrapper.children[0];
          const gap   = parseFloat(getComputedStyle(this.wrapper).gap) || 0;
          const fw    = first.offsetWidth + gap;

          // Advance our target, then lerp toward it
          this.lerp.target += this.pxPerFrame;
          this.lerp.current = this._lerp(this.lerp.current, this.lerp.target, this.factor);

          // If we've scrolled past one item, cycle it to the end
          if (this.lerp.current >= fw) {
            this.wrapper.appendChild(first);
            this.lerp.current -= fw;
            this.lerp.target  -= fw;
          }

          // Always include the gutter offset
          const x = this.lerp.current + this.gutter;
          this.wrapper.style.transform = `translateX(-${x}px)`;
        }
      }
      requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }

  _lerp(c, t, f) {
    return c * (1 - f) + t * f;
  }
}

customElements.define('cart-drawer-usp-bar', AnimatedCartUspsBar);


class QuoteSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiper = this.element.querySelector(".swiper");



    if(this.swiper)
    {
      new RevolutionSwiper(this.swiper);
      this.handleClampedText();
    }


    const slides = this.swiper.querySelectorAll('.swiper-slide');
    if(slides && responsive.matchesBreakpoint("lap_and_up") && slides.length < 5){
      const navElement = this.element.querySelector(".quote-section__footer");
      navElement.style.display = "none";
    }
  }

  handleClampedText(){
    this.clampedText = this.element.querySelectorAll(".swiper-slide > .text-block__text");

    this.clampedText.forEach(el => {
      const paragraph = el.querySelector("p");
      const swiperSlide = el.closest(".swiper-slide");
      const link = swiperSlide.getAttribute("href");

      const computedStyle = getComputedStyle(paragraph);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const lines = Math.round(paragraph.offsetHeight / lineHeight);

      if (lines >= 4 && link) {
        const readMore = document.createElement("a");
        readMore.href = link;
        readMore.className = "u-p3";
        readMore.style.marginTop= "4px";
        readMore.textContent = "Read more";
        el.appendChild(readMore);
      }
    });

  }
}


customElements.define("quote-section", QuoteSection);

class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateBody    = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);

    // instantiate country + (empty) language selectboxes
    this.element
      .querySelectorAll('.RevolutionSelectbox')
      .forEach(el => new RevolutionSelectbox(el));

    this.bindEvents();

    // — run once on load, to hide/show & populate the language dropdown for the default market —
    this.updateLanguageOptions({
      detail: {
        languages: this.element.dataset.defaultLanguages,
        country:   this.element.dataset.defaultMarket
      }
    });
  }

  bindEvents() {
    this.delegateBody.on("change:countrySelector", this.updateLanguageOptions.bind(this));
    this.delegateElement.on("keydown", '[data-action="select-language"]', this.selectLanguage.bind(this));
    this.delegateElement.on("click", '[data-action="custom-country-redirect"]', this.redirectToCustomUrl.bind(this));
  }

  selectLanguage(e, target) {
    if (e.key === 'Enter') target.previousElementSibling.checked = true;
  }

  redirectToCustomUrl(e, target) {
    const url = target.getAttribute('data-url');
    if (url) {
      window.location.href = url;
    }
  }

  updateLanguageOptions(e) {
    let languages;
    try {
      languages = JSON.parse(e.detail.languages);
    } catch (err) {
      console.error("Invalid languages JSON", err);
      return;
    }

    const wrapper     = this.element.querySelector('.country-selector__dropdown--language');
    if (!wrapper) return;

    const selectboxEl = wrapper.querySelector('.RevolutionSelectbox--Selectors');
    if (!selectboxEl) return;

    const innerList   = selectboxEl.querySelector('.RevolutionSelectbox--InnerContent');
    const input       = selectboxEl.querySelector('input');
    const titleEl     = selectboxEl.querySelector('.RevolutionSelectbox--Title');

    // If only one (or zero) languages → hide & bail
    if (languages.length <= 1) {
      wrapper.style.display = 'none';
      if (languages[0]) {
        document.documentElement.lang = languages[0].iso;
        input.value = languages[0].iso;
        titleEl.textContent = languages[0].name;
      }
      return;
    }

    // Otherwise → show, clear, rebuild
    wrapper.style.display = '';
    innerList.innerHTML   = '';

    // preserve prior selection or default to first
    const prevIso = input.value?.toLowerCase();
    let chosenIso, chosenName;

    languages.forEach((lang, idx) => {
      const item = document.createElement('div');
      item.className           = 'RevolutionSelectbox--Item u-p3';
      item.setAttribute('tabindex','0');
      item.dataset.value       = lang.iso;
      item.dataset.name        = lang.name;
      item.dataset.selectboxid = 'country-selector__language_code';
      item.dataset.action      = 'selectbox-change';
      item.textContent         = lang.name;

      if (
        (prevIso && lang.iso.toLowerCase() === prevIso) ||
        (!prevIso && idx === 0)
      ) {
        item.setAttribute('selected','selected');
        chosenIso  = lang.iso;
        chosenName = lang.name;
      }

      innerList.appendChild(item);
    });

    // update input + button title
    input.value         = chosenIso;
    titleEl.textContent = chosenName;

    // re-init just the language selectbox so the plugin picks up the new items
    new RevolutionSelectbox(selectboxEl);
  }
}

customElements.define("localization-modal", LocalizationModal);




class AnimationText extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.animHolder = this.element.querySelector(".metaItem--animHolder");
    this.initListener = this.init.bind(this);
    this.init();
  }

  init(){
    this.lerp = { current: 0, target: 0 };
    this.interpolationFactor = 0.1;
    this.speed = this.element.dataset.speed / 100;
    this.direction = -1; // -1 (to-left), 1 (to-right)
    this.cloneElements();

    this.resizeObserver = new ResizeObserver(changes => {
      for(const change of changes){
        this.element.style.cssText = `position: absolute; display: inline-flex; white-space: nowrap; width: ${change.contentRect.width + 16}px`;
        this.element.children[1].style.cssText = `position: absolute; left: calc(${
          change.contentRect.width * -this.direction
        }px + 16px); width: fit-content; justify-content: flex-start`;

        this.render();
      }
    })

    this.resizeObserver.observe(this.animHolder);
  }


  cloneElements() {

    const fragment = document.createDocumentFragment();
    this.animHolder.classList.add("mr-l");
    this.animHolder.style.justifyContent = "flex-start";
    this.animHolder.style.width = "fit-content";
    for (var i = 0; i < this.element.childNodes.length; i++) {
      const clonedChild = this.element.childNodes[i].cloneNode(true);
      fragment.appendChild(clonedChild);
    }

    this.element.appendChild(fragment);
  }

  animate() {

    function lerp(start, end, t) {
  return start + (end - start) * t;
}

    this.lerp.target += this.speed;
    this.lerp.current = lerp(
      this.lerp.current,
      this.lerp.target,
      this.interpolationFactor
    );



    if (this.lerp.target > 100) {
      this.lerp.current -= this.lerp.target;
      this.lerp.target = 0;
    }

    const x = this.lerp.current * this.direction;
    this.element.style.transform = `translateX(${x}%)`;
  }

  render() {
    this.animate();
    window.requestAnimationFrame(() => this.render());
  }
}

customElements.define("animation-text", AnimationText);

class BannerHero extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    const self = this;
    this.delegateElement = new Delegate(this.element);
    this.contentWrapper = this.element.querySelector(".rating");


    const element = this.element.querySelector(".hero-banner__outer-wrapper .hero-banner-txt-content__wrapper");
    const allSections = document.querySelectorAll("banner-hero");
    const headerHeightVar = document.querySelector(".header");
    const elementY = allSections[0].getBoundingClientRect().y;

    if (elementY === headerHeightVar.getBoundingClientRect().height) {
      const mediaContainer =  allSections[0].querySelector(".media-text-wrapper")
      const sectionWrapper =  allSections[0].querySelector(".media-container__wrapper")
      mediaContainer.style.borderTopLeftRadius = "0";
      mediaContainer.style.borderTopRightRadius = "0";
      mediaContainer.style.overflow = "auto";
      sectionWrapper.style.padding = "0px";
    }

    if (!element || element.innerHTML.trim() === "") {
      if (element) {
        element.style.display = "none";
      }
    } else {
        if (element) {
            element.style = "";
        }
    }

    if(this.contentWrapper) {
      document.documentElement.style.setProperty(
          "--animate-wrapper-width",
          this.contentWrapper.getBoundingClientRect().width + "px"
      );

      this.bindEvents();
    }

  }

  bindEvents() {
    window.addEventListener("scroll", this.updateVisibleContent.bind(this));
    window.addEventListener("resize", this.updateVisibleContent.bind(this));
  }

  updateVisibleContent() {
    document.documentElement.style.setProperty(
        "--animate-wrapper-width",
        this.contentWrapper.getBoundingClientRect().width + "px"
    );
  }
}
customElements.define("banner-hero", BannerHero);



class GradientDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);


    this.dropdowns = this.element.querySelectorAll('.custom__dropdown__gradient');

    if(this.dropdowns){
      this.gradientDropdown()
    }
  }

  gradientDropdown() {
    this.dropdowns.forEach((dropdown, index) => {
      const color = getComputedStyle(this.dropdowns[0]).backgroundColor;

      // Convert to HSL
      const hsl = this.rgbToHsl(color);
      if (!hsl) return; // Skip if conversion fails

      // Adjust lightness based on index
      const adjustedLightness = Math.min(hsl.l + index * 3, 100);

      // Apply styles
      dropdown.style.zIndex = index + 1;
      dropdown.style.backgroundColor = `hsl(${hsl.h}, ${hsl.s}%, ${adjustedLightness}%)`;
      dropdown.style.position = 'relative';
      dropdown.style.marginTop = index > 0 ? '-1.49rem' : '0';
    });
  }


  rgbToHsl(rgbString) {
    if (typeof rgbString !== 'string') return null;

    // Match RGB or RGBA values
    const match = rgbString.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
    if (!match) return null;

    const [r, g, b] = match.slice(1, 4).map(Number).map(v => v / 255);
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h = 0, s = 0;
    const l = (max + min) / 2;

    if (max !== min) {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h *= 60;
    }

    return {
      h: Math.round(h),
      s: Math.round(s * 100),
      l: Math.round(l * 100)
    };
  }
}

customElements.define("gradient-dropdown", GradientDropdown);



class BlogShowcaseSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");

    if (!responsive.matchesBreakpoint('lap_and_up')) {
     this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
}

customElements.define("blog-showcase", BlogShowcaseSlider);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".blog__tags--swiper.swiper");
    this.activeSlide = this.element.querySelector(".blog__current-tag");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
  }

  connectedCallback() {
    
    if (this.carouselElement && this.breakpoint === "phone" || this.breakpoint === "pocket") {
      const swiperElement = new RevolutionSwiper(this.carouselElement);
      const slides = Array.from(this.carouselElement.querySelectorAll(".swiper-slide"));
      const activeIndex = slides.indexOf(this.activeSlide);

      swiperElement.swiperElement.slideTo(activeIndex)
    }
  }
}

customElements.define("blog-section", BlogSection);

class ArticleComments extends HTMLElement {
  constructor() {
    super();
    // Read total comments from the HTML attribute
    this.totalComments = parseInt(this.dataset.totalComments, 10) || 0;
    this.remainingCountSpan = this.querySelector('.article-comments__remaining-count');

    // Core elements
    this.delegateElement = new Delegate(this);
    this.articleWrapper = this.querySelector(".article-comments__main-container");
    this.showLessButton = this.querySelector(".article-comments__show-less-button");
    this.commentForm = this.querySelector("#comment_form");

    // Bind form submit
    if (this.commentForm) {
      this.commentForm.addEventListener("submit", this.customSubmit.bind(this));
    }

    // Restore focus after comment submit
    const commentContainer = this.querySelector('.comment-form__container');
    if (sessionStorage.getItem('comment-submitted')) {
      sessionStorage.removeItem('comment-submitted');
      if (commentContainer) {
        commentContainer.setAttribute('tabindex', '-1');
        commentContainer.focus();
      }
    }

    // Wire events and initial UI state
    this.bindEvents();
    this.toggleButton();
    this.updateRemaining();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="load-more"]', this.loadMore.bind(this));
    this.delegateElement.on("click", '[data-action="show-less"]', this.showLess.bind(this));
    this.delegateElement.on("click", '[data-action="scroll-to-comment-form"]', this.scrollToCommentForm.bind(this));
    this.delegateElement.on("change", "[data-state='required']", this.toggleButton.bind(this));
  }

  toggleButton() {
    let enabled = true;
    this.querySelectorAll("[data-state='required']").forEach(field => {
      if (field.type === "checkbox" ? !field.checked : field.value.trim() === "") {
        enabled = false;
      }
    });
    const submitBtn = this.querySelector(".article-comments__submit-button");
    if (submitBtn) {
      enabled ? submitBtn.removeAttribute("disabled") : submitBtn.setAttribute("disabled", true);
    }
  }

  escapeSelector(id) {
    if (/^\d/.test(id)) {
      return `\\3${id[0]} ${id.slice(1)}`;
    }
    return id.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }

  updateRemaining() {
    const shown = this.querySelectorAll('.article-comments__comment').length;
    const remaining = this.totalComments - shown;
    // update the number (in parentheses)
    if (this.remainingCountSpan) {
      this.remainingCountSpan.textContent = remaining > 0 ? `(${remaining})` : '';
    }

    // always ensure it's inside the ButtonText
    const btnText = this.querySelector('.article-comments__load-more-button .ButtonText');
    if (btnText && this.remainingCountSpan) {
      btnText.appendChild(this.remainingCountSpan);
    }
  }

  async loadMore(event, target) {
    event.preventDefault();
    const href = target.dataset.href;
    if (!href) return console.error("Missing data-href on load-more");

    const loader = this.querySelector(".article-comments__load-more-button .itemLoader");
    try {
      loader?.classList.add("is-visible");
      await new Promise(r => setTimeout(r, 300));

      const resp = await fetch(`${window.routes.localeRootUrl}${href}`, { credentials: "same-origin" });
      if (!resp.ok) throw new Error(resp.statusText);
      const html = await resp.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      // Append new comments
      doc.querySelectorAll(".article-comments__comment").forEach(c => {
        const id = c.getAttribute('id') && this.escapeSelector(c.getAttribute('id'));
        if (!id || this.querySelector(`#${id}`)) return;
        this.articleWrapper.appendChild(c);
      });
      new RevolutionAnimation(this);

      // Swap or remove Load more button
      const newBtn = doc.querySelector("[data-action='load-more']");
      const oldBtn = this.querySelector(".article-comments__load-more-button");
      const btnContainer = this.querySelector('.article-comments__buttons');

      if (newBtn) {
        oldBtn.replaceWith(newBtn);
        this.showLessButton.classList.add('hidden'); // still more pages
      } else {
        oldBtn.remove();
        btnContainer.appendChild(this.showLessButton);
        this.showLessButton.classList.remove('hidden'); // end reached
      }

      this.updateRemaining();
    } catch (err) {
      console.error("Failed to load more comments:", err);
    } finally {
      loader?.classList.remove("is-visible");
    }
  }

  async showLess(event, target) {
    event.preventDefault();
    const url = target.dataset.firstPageUrl;
    if (!url) return;

    try {
      const resp = await fetch(`${window.routes.localeRootUrl}${url}`, { credentials: "same-origin" });
      if (!resp.ok) throw new Error(resp.statusText);
      const html = await resp.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      // Restore first page comments
      const comments = doc.querySelectorAll(".article-comments__comment");
      this.articleWrapper.innerHTML = "";
      comments.forEach(c => this.articleWrapper.appendChild(c));
      new RevolutionAnimation(this);

      // Hide Show Less, restore Load More
      this.showLessButton.classList.add('hidden');
      const loadMoreBtn = doc.querySelector(".article-comments__load-more-button");
      if (loadMoreBtn) {
        this.querySelector('.article-comments__buttons').appendChild(loadMoreBtn);
      }

      this.updateRemaining();

      // Scroll back up
      const top = this.getBoundingClientRect().top + window.scrollY - 150;
      window.scrollTo({ top, behavior: 'smooth' });
    } catch (err) {
      console.error("Failed to show less:", err);
    }
  }

  scrollToCommentForm(event) {
    event.preventDefault();
    if (!this.commentForm) return;
    const rect = this.commentForm.getBoundingClientRect();
    window.scrollTo({ top: rect.top + window.scrollY - 150, behavior: 'smooth' });
  }

  customSubmit(event) {
    sessionStorage.setItem('comment-submitted', 'true');
    event.preventDefault();
    // ... your existing title/tag injection logic ...
    this.commentForm.submit();
  }
}

customElements.define("article-comments", ArticleComments);





class ProductShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".product-showcase__swiper");
    this.carouselElementSecondary = this.element.querySelector(".product-showcase-secondary__swiper");

    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.syncThumbnailHeight();
    this.copyButtonContent();
    this.insertSecondarySlides();

    this.carouselSecondary = new RevolutionSwiper(this.carouselElementSecondary);
    this.carousel.element.swiper.controller.control = this.carouselSecondary.element.swiper;
    this.carouselSecondary.element.swiper.controller.control = this.carousel.element.swiper;

    // Hide pagination & buttons if less than 2 slides
    const mediaWrappers = this.carouselElement.querySelectorAll('.media-group__primary-wrapper');
    if (mediaWrappers.length < 2) {
      const pagination = this.element.querySelector('.swiper-pagination');
      if (pagination) pagination.style.display = 'none';

      const allButtons = this.element.querySelectorAll('.swiperButton, .swiperButtonNext, .swiperButtonPrevious');
      allButtons.forEach(btn => {
        btn.style.display = 'none';
        btn.classList.remove('swiper-button-lock');
      });
    }

    this.resizeListener = responsive.addResizeListener(this, this.syncThumbnailHeight);
  }

  copyButtonContent() {
    const source = this.element.querySelector('.product-showcase__button.not_desktop');
    const target = this.element.querySelector('.product-showcase__button.not_mobile.not_pocket');

    if (source && target) {
      const clones = Array.from(source.children).map(child => child.cloneNode(true));
      target.innerHTML = '';
      clones.forEach(clone => target.appendChild(clone));
    }
  }

  syncThumbnailHeight() {
    const primary = this.querySelector('.media-group__primary-wrapper');
    const secondary = this.querySelector('.product-showcase-pagination');
    if (primary && secondary) {
      const top = primary.offsetHeight - 28;
      secondary.style.top = `${top}px`;
    }
  }

  insertSecondarySlides() {
    const sourceSlides = this.element.querySelectorAll('.product-showcase__swiper .swiper-slide');
    const targetWrapper = this.element.querySelector('.product-showcase-secondary__swiper .product-showcase__swiper--wrapper');

    if (!targetWrapper) return;

    sourceSlides.forEach(originalSlide => {
      const clonedSlide = originalSlide.cloneNode(true);

      // Ukloni .not_desktop s richtexta
      const richtext = clonedSlide.querySelector('.media-group__richtext.not_desktop');
      if (richtext) richtext.classList.remove('not_desktop');

      // Zamijeni sadržaj primary sadržajem iz secondary
      const secondary = clonedSlide.querySelector('.media-group__secondary.not_desktop');
      const primary = clonedSlide.querySelector('.media-group__primary');

      if (secondary && primary) {
        primary.innerHTML = secondary.innerHTML;
      }

      targetWrapper.appendChild(clonedSlide);
    });
  }

  disconnectedCallback() {
    if (this.resizeListener?.removeResizeListener) {
      this.resizeListener.removeResizeListener();
    }
  }
}

customElements.define("product-showcase", ProductShowcase);

class InfiniteScroll {
  constructor(container, paginationElement, restoreState) {
    console.log('InfiniteScroll initialized', container, paginationElement, restoreState);
    if (
      !document.querySelector(container) ||
      !document.querySelector(paginationElement)
    )
      return;


    this.containerSelector = container;
    this.paginationElementSelector = paginationElement;
    this.restoreState = restoreState;
    this.treshold = 650;
    this.domDelegate = new Delegate(document.body);
    this.mainContainer = document.querySelector(this.containerSelector);
    this.loadType = 'scroll'; // default to scroll, can be overridden
    this.running = false;
    this.bindEvents();

    const pageAccessedByReload =
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType("navigation")
        .map((nav) => nav.type)
        .includes("reload");

    if (
      this.restoreState &&
      sessionStorage.getItem("pageState") > 1 &&
      window.location.href === sessionStorage.getItem("pageStateURL") &&
      !pageAccessedByReload
    ) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initObserver();
    }
  }

  initObserver() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      observerOptions
    );
    this.observer.observe(this.mainContainer);
  }

  bindEvents() {
    this.handleClickBinder = this.handleClick.bind(this);
    this.handleScrollBinder = this.handleScroll.bind(this);



    if (this.restoreState) {
      window.addEventListener(
        "beforeunload",
        this.rememberCurrentState.bind(this)
      );
    }
  }

  rememberCurrentState() {
    const scrollPositionY = window.scrollY;
    const currentUrl = window.location.href;
    const currentPage = document.querySelector(this.paginationElementSelector)?.dataset.page;

    sessionStorage.setItem("pageState", currentPage);
    sessionStorage.setItem("pageStateURL", currentUrl);
    sessionStorage.setItem("pageStateScroll", scrollPositionY);
  }

  initialize() {
    if (this.loadType === "scroll") {
      window.addEventListener("scroll", this.handleScrollBinder);
    } else {

      this.domDelegate.on(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  destroy() {
    if (this.loadType === "scroll") {
      window.removeEventListener("scroll", this.handleScrollBinder);
    } else {
      this.domDelegate.off(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.running === false) {
          this.initialize();
          this.running = true;
        }
      } else {
        this.running = false;
        this.destroy();
      }
    });
  }

  handleScroll() { 


    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );


    if (!this.paginationElement) return;

    const top =
      this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom =
      this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement;

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick(e) {
    e.preventDefault();
    e.target
      .closest("a")
      .querySelector(".itemLoader")
      .classList.add("is-visible");

    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );


    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector("a");

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;
      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem("pageState"));
      for (let i = 2; i <= limit; i++) {
        let url;

        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(
          fetch(url, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(
        fetch(url, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    }

    return promises;
  }

  async renderData(promises, restoreContent) {


    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(
        responses.map((response) => response.text())
      );
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;

        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
    }
  }

  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const contentToAdd = doc.querySelector(this.containerSelector);

    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    this.mainContainer.insertAdjacentHTML("beforeend", contentToAdd.innerHTML);

    if (lastPromise) {
      this.initialize();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );

    new RevolutionAnimation(this.mainContainer);
  }

  restoreScroll() {
    const scrollPosition = parseInt(sessionStorage.getItem("pageStateScroll"));

    if (scrollPosition) {
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }
}